import React, { Component } from 'react';
import CustomModal from './index';
import {
  ColorButton,
  ValueText,
  SwitchContainer,
  DropFile,
  AddCostTypeModal,
  SelectDropdown,
  ImageModal
} from '../../../../index';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Help from '../../../../../assets/images/module/general/Help.svg';
import calendar from '../../../../../assets/images/module/general/CalendarIcon.svg';
import { connect } from 'react-redux';
import RangeDatePicker from './DateRangePicker';
import Autoload from '../../../../Autoload';
import { isStarterTier } from '../../../../../helpers/subscriptionFeatureAccess';
import moment from 'moment';
import GlobalServices from '../../../../helpers/services/GlobalServices';
import GeneralDataHandler from '../../../../helpers/DataHandler/General';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';

import { hideNotification, showNotification } from '@mantine/notifications';
import RedTick from '../../../../../assets/images/module/general/RedTick.svg';
import RedCross from '../../../../../assets/images/module/general/RedCross.svg';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import CloseButtonIcon from '../../../../../assets/images/module/general/CloseButtonIcon.svg';
import GoldenLockIcon from '../../../../../assets/images/module/general/GoldenLockIcon.svg';
import AddPages from '../../../../../assets/images/module/general/FileAdd.svg';
import RemovePages from '../../../../../assets/images/module/general/FileRemove.svg';

// Get receipts endpoint from new config
import { config } from '../../../../config/Setting';
import { Check } from "@material-ui/icons";
import { Alert, Box, Group, LoadingOverlay, NumberInput, Overlay, Popover, Stack, Text, Textarea, TextInput } from "@mantine/core";
import * as customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs';
import { NumericFormat } from 'react-number-format';
import PdfViewer from '../PdfViewer/PdfViewer';
import { Button } from 'reactstrap';
import { ChevronRight, ChevronLeft, ZoomIn, ZoomOut, NoteAdd} from '@material-ui/icons';
import ExpandIcon from '../../../../../assets/images/module/general/ExpandIcon.svg';
import UtilityBillingAssignedIcon from '../../../SVGs/utilityBillingAssigned';
import {setAddReceiptModal, setReceiptCurrentId, setReceiptFiles, setRefreshReceiptDocumentsData} from '../../../../../redux/action/General/generalActions';
import BuyPremiumModal from './BuyPremiumModal';
import PaymentMethodRequiredModal from '../../../../../components/PaymentMethodRequiredModal';
import { requiresPaymentMethodForStorage } from '../../../../../helpers/subscriptionBilling';
import { formatNumber } from '../../../../../helpers/stringsManipulations';
import html2canvas from 'html2canvas';
import jsPdf from 'jspdf';
import { PDFDocument, rgb, degrees } from 'pdf-lib';
import MultipleReceiptsUploadModal from './MultipleReceiptsUploadModal';
import AddMultipleDocumentsCofirmationModal from './AddMultipleDocumentsCofirmationModal';
import EXIF from 'exif-js';
import AddHeatingCostModal from './AddHeatingCostModal';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
var { checkProperty, yearDifference, yearDifferenceMoment, loader, isPdfFile } = Autoload.MainHelper;
dayjs.extend(customParseFormat);

const areEqual = (prevProps, nextProps) => (prevProps.billingRelevantSwitch === nextProps.billingRelevantSwitch && prevProps.file.size === nextProps.file.size);
const FilePreview = React.memo(({file, billingRelevantSwitch=false, edit, onExpand, costAllocation, isMobile, addFile, removePage}) => {
  const [imgScale, setImgScale] = React.useState(100);
  if (file) {
    let re = /(?:\.([^.]+))?$/;
    var extension = re.exec(!edit ? file.name : typeof(file) === 'object' ? file.name : file)[1];
    extension = extension && extension.split('?')[0];
  
    if (extension === 'jpg' || extension === 'png' || extension === 'jpeg') {
      const url = !edit ? URL.createObjectURL(file) : typeof(file) === 'object' ? URL.createObjectURL(file) : file;
      return (
      <div style={{width: `${imgScale}%`, textAlign:'center'}}>
        <img src={url} className="main-img" alt="no" />
        <div style={{textAlign: 'left', position: 'absolute', //bottom: !isMobile && 27, 
        top: isMobile ? 367 : 667, left: 4}}> 
          <nav>
              <Button size={'sm'} disabled={imgScale === 200} onClick={() => setImgScale(imgScale + 10)} children={<ZoomIn/>}/>
              {' '}
              <Button size={'sm'} disabled={imgScale === 100} onClick={() => setImgScale(imgScale - 10)} children={<ZoomOut/>}/>
              {' '}
              <Button size={'sm'} onClick={() => onExpand()} children={<img src={ExpandIcon}/>}/>
          </nav>
        </div>
      </div>
      );
    } else if (typeof(file) === 'object') {
      const url =URL.createObjectURL(file);
      return (
        <PdfViewer file={url} preview={true} costAllocation={!costAllocation} billingRelevantSwitch={billingRelevantSwitch} onExpand={()=> onExpand()} addFile={()=> addFile()} removePage={(pageNumber)=> removePage(pageNumber)}/>
      );
    } else {
      return (
        <Stack style={{width: '100%', height: isMobile ? '400px' : '700px'}} justify='center' align={'center'}>
          <Group style={{width: '100%', height: '100%'}} justify='center' align={'center'}>
            <img src={Receipt} style={{objectFit: 'cover'}} className="main-img" alt="no" />
          </Group>
        </Stack>
      );
    }
  }
}, areEqual); 

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

class ReceiptDetailModal extends Component {
  initialState = {
    receiptName: '',
    receiptNameErr: false,
    amount: null,
    amountErr: false,
    netAmount: null,
    vatAmount: null,
    laborCost: null,
    date: new Date(),
    UtilityBillFilter: false,
    costTypeOptions: [],
    selectedCostType: [],
    timeframe: 'current',
    timeframeToSend: {},
    selectedFile: null,
    selectedFiles: [],
    deletedFile: false,
    editedFile: false,
    selectedFileErr: { state: false, msg: 'No file selected' },
    customDate: {
      start: null,
      end: null,
    },
    AddCostTypeModal: false,
    //disables multiselect
    multiselectEnable: true,
    cosTypeErr: false,
    isFormValid: false,
    errors: {
      title: null,
      amount: null,
      costType: null,
      heatigCostType: null
    },
    billingPeriods: [],
    imageOpen: false,
    currentStartDate: '',
    currentEndDate: '',
    previousStartDate: '',
    previousEndDate: '',
    imgScale: 100,
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    vatTypes: [
      {label: '19,00 %'},
      {label: '7,00 %'},
      {label: 'anderer'}
    ],
    taxCostTypes: [
      // {label: 'Abschreibungen für GWG'},
      {label: 'Schuldzinsen'},
      {label: 'Geldbeschaffungskosten'},
      {label: 'Erhaltungsaufwendungen'},
      {label: 'Laufende Betriebskosten'},
      {label: 'Verwaltungskosten'},
      {label: 'Sonstige Kosten'},

      {label: 'Erstattete Vorauszahlungen'},
      {label: 'Erhaltene Nachzahlungen'},
      {label: 'Vereinnahmte Kautionen / Mieten aus Vorjahren'},
      {label: 'Vom Finanzamt erstattete Umsatzsteuer'},
      {label: 'Öffentliche Zuschüsse'},
      {label: 'AfA Gebäude'},
      {label: 'AfA bewegliche Wirtschaftsgüter'},
      {label: 'An Finanzamt gezahlte Umsatzsteuer'},
      {label: 'Renten, dauernde Lasten'},
    ],
    selectedVatType: [],
    customVatType: null,
    selectedTaxCostType: [],
    aiLoader: false,
    hoverOnStarter: false,
    error: [],
    openPaidModal: false,
    vatInFocus: false,
    laborCostInFocus: false,
    netInFocus: false,
    vatPercentInFocus: false,
    amountInFocus: false,
    notes: null,
    receiptNumber: null,
    openPaidModalForTaxCostType: false,
    openMultipleReceiptsUploadModal: false,
    openAddMultipleDocumentsCofirmationModal: false,
    acceptedFiles: [],
    rejectedFiles: [],
    amountType: null,
    firstTimeAmountNegative: true,
    fileWasEdited: false,
    selectedFileEncrypted: false,
    systemHeatingCostTypes: [],
    heatingCostType: null,
    addHeatingCostModalOpen: false,
    receiptId: null
  };

  // currentStartDate;
  // currentEndDate;
  // previousStartDate;
  // previousEndDate; 

  constructor(props) {
    super(props);
    this.multiselectRef = React.createRef();
    this.state = this.initialState;
    props.propertySelected && this.getBillingPeriods('currentBillingPeriod');
    loader(true);

    this.fileInputRef = React.createRef();
  }

  formatDates = (billingPeriods) => {
    if(billingPeriods.length != 0){
      let filteredBillingPeriods= billingPeriods
      // .filter((value, index, self) =>
      // index === self.findIndex((t) => (
      //   t.startDate === value.startDate && t.endDate === value.endDate
      // )))
      this.setState({
        currentEndDate: dayjs(filteredBillingPeriods[0].endDate).format('DD.MM.YYYY'),
        currentStartDate: dayjs(filteredBillingPeriods[0].startDate).format('DD.MM.YYYY'),
        previousEndDate: filteredBillingPeriods[1] ? dayjs(filteredBillingPeriods[1].endDate).format('DD.MM.YYYY') : '',
        previousStartDate: filteredBillingPeriods[1] ? dayjs(filteredBillingPeriods[1].startDate).format('DD.MM.YYYY'): ''
      }, ()=> loader(false));
    }
  }

  toggleAddCostTypeModal = () => {
    this.setState({ AddCostTypeModal: !this.state.AddCostTypeModal });
  };

  componentDidMount() {
    const {transactionAssigment=null, aiSuggestedReceipt=null, edit} = this.props;
    console.log('window.location: ', window.location.pathname);
    // 1 call dropdown options api
    // this._calDropdownOption();
    // this.setState({ selectedCostType: this.props.selectedCostType });
    // getCostTypes already supports preselecting one by id, which is how the AI assignment
    // suggestion's proposed cost type gets into the form: it has to be applied here rather
    // than by a setState below, because the dropdown's options don't exist until this call
    // comes back.
    this.getCostTypes(aiSuggestedReceipt?.costTypeId || null);

    if(transactionAssigment){
      console.log('componentDidMount: ', transactionAssigment);
      this.setState({
        // The AI's proposed name when there is one ("Stadtwerke München - Abschlag Strom"),
        // otherwise the raw counterparty as before. Everything else still comes straight off
        // the transaction — the suggestion never restates an amount or a date it was given.
        receiptName: aiSuggestedReceipt?.name || transactionAssigment.counterpartName,
        amount: transactionAssigment.amount,
        date: new Date(transactionAssigment.bankBookingDate),
        notes: transactionAssigment.purpose
      });
    }
    if(edit){
      this.setState({firstTimeAmountNegative: false});
    }
    // console.log(this.props);
  }
  componentDidUpdate() {
    // this.state.costTypeOptions.length === 0 && this.getCostTypes();
  }

  getSystemHeatingCostTypes=(stopGetReceiptDetails=false)=>{
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'heatingCostSystemTypes?propertyId='+this.props.propertySelected.id,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleGetSystemHeatingCostTypes',
      {stopGetReceiptDetails},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleGetSystemHeatingCostTypes(response){
    if(response.status && response.statuscode === 200){
      let data = response.result.map((item)=> {
        return ({...item, id: item.id || item.heatingCostTypeName});
      });
      this.setState({systemHeatingCostTypes: data});
    }

    if(this.props.edit && response.other.stopGetReceiptDetails === false) {
      this._getReceiptDetails();
    }
  }

  getCostTypes(id=null) {
    console.log('getCostTypes: ', id);
    this.props.propertySelected && GlobalServices._getCostTypeByProperty(this, '_handleCostTypeDropDown', this.props.propertySelected, id);
  }

  _handleCostTypeDropDown(response) {
    console.log(response, 'get cost type response');
    // if (response.statuscode == 404) {
    //   this.setState({ multiselectEnable: false });
    // }
    if (response.statuscode === 500) {
      this.setState({ multiselectEnable: true });
    } else {
      const keys = GeneralDataHandler.getCostTypes(response.result);
      const costTypes = keys.filter((keys) => keys.useInReceiptMgmt === true);
      //  console.log(costTypes,'add cost type')
      //
      this.setState({costTypeOptions: costTypes, multiselectEnable: false});
      const preselectedCostType = response.other && costTypes.find((costType)=> costType.id === response.other);
      if(preselectedCostType){
        this.setState({selectedCostType: [preselectedCostType]});
      }
    }
    console.log(this.state.costTypeOptions, 'cost type optioins');
  }

  _getReceiptDetails() {
    Autoload.HttpRequestAxios.HttpRequest(
      // Autoload.Setting.rm_api_base_url + 'receipts/' + this.props.record.id,
      Autoload.Setting.rm_api_base_url + 'receipt/' + this.props.record.id, // not according to swagger
      // Autoload.Setting.receipts + this.props.record.id,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_getReceiptDetailsResponse',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  _getReceiptDetailsResponse(response) {
    console.log('_getReceiptDetailsResponse: ', response);
    if (response.status === true && response.statuscode === 401) {
      localStorage.clear();
      window.location.reload();
    }

    if (response.status === true && response.statuscode === 200) {
      const cost =
        checkProperty(response.result, 'costs') === ''
          ? checkProperty(response.result, 'cost')
          : checkProperty(response.result, 'costs');
      const date =
        checkProperty(response.result, 'receiptDate', '') === ''
          ? checkProperty(response.result, 'date', '')
          : checkProperty(response.result, 'receiptDate', '');
      const receiptPeriodStart = checkProperty(response.result, 'receiptPeriodStart', '');
      const receiptPeriodEnd = checkProperty(response.result, 'receiptPeriodEnd', '');

      console.log('response recipet modal', response.result);

      this.setState(
        {
          receiptId: response.result.id,
          receiptName: checkProperty(response.result, 'name'),
          receiptNameErr: false,
          date: this.formatDate(dayjs(date).format('DD.MM.YYYY')),
          receiptPeriodStart: this.formatDate(dayjs(receiptPeriodStart).format('DD.MM.YYYY')),
          receiptPeriodEnd: this.formatDate(dayjs(receiptPeriodEnd).format('DD.MM.YYYY')),
          utilityBillingRelevant: checkProperty(response.result, 'utilityBillingRelevant', ''),
          // amount: Autoload.MainHelper.ConverterCurrencyDe(cost + ''),
          amount: cost,
          selectedCostType: checkProperty(response.result, 'selectedCostTypes')
            ? checkProperty(response.result, 'selectedCostTypes').map((costType) => {
              return {
                id: checkProperty(costType, 'id'),
                costTypeName: checkProperty(costType, 'costTypeName'),
                propertyId: checkProperty(costType, 'propertyId'),
                systemCostType: checkProperty(costType, 'systemCostType'),
                useInReceiptMgmt: checkProperty(costType, 'useInReceiptMgmt'),
                heatingCostType: checkProperty(costType, 'heatingCostType'),
                allocationKey: {
                  allocationKeyId: checkProperty(costType.allocationKey, 'allocationKeyId'),
                  allocationKeyName: checkProperty(costType.allocationKey, 'allocationKeyName'),
                  propertyId: checkProperty(costType.allocationKey, 'propertyId'),
                  units: checkProperty(costType.allocationKey, 'units'),
                  metered: checkProperty(costType.allocationKey, 'metered'),
                  systemAllocationKey: checkProperty(costType.allocationKey, 'systemAllocationKey'),
                },
                systemCostTypeId: costType?.systemCostTypeId
              };
            })
            : [],
          amountErr: false,
          UtilityBillFilter: checkProperty(response.result, 'utilityBillingRelevant', false),
          timeframe: this.setTimeFrame(
            checkProperty(response.result, 'receiptPeriodStart', '') +
            ' - ' +
            checkProperty(response.result, 'receiptPeriodEnd', '')
          ),
          selectedFile:
            checkProperty(response.result, 'file_name') === ''
              ? checkProperty(response.result, 'fileName')
              : checkProperty(response.result, 'file_name'),
          selectedFileErr: { state: false, msg: 'No file selected' },
          selectedVatType: [response.result.vatPercent && (response.result.vatPercent === 19 || response.result.vatPercent === 7) ? {label: `${response.result.vatPercent.toString()},00%`} : {label: 'anderer'}],
          customVatType: response.result.vatPercent && (response.result.vatPercent !== 19 && response.result.vatPercent !== 7) ? response.result.vatPercent : null,
          vatAmount: response.result.vatAmount,
          netAmount: response.result.netAmount,
          laborCost: response.result.laborCost,
          selectedTaxCostType: [response.result.taxCostType && {label: response.result.taxCostType}],
          receiptNumber: response.result.receiptNumber,
          notes: response.result.notes,
          heatingCostType: this.state.systemHeatingCostTypes.find((heatingCostType)=> heatingCostType.heatingCostTypeName === response.result?.heatingCostType)
          // selectedCostType: this.setSelectedCost(checkProperty(this.props.record, 'cost_type')),
          // customDate: (this.state.timeframe === 'custom') ? this.setCustomDate(checkProperty(this.props.record, 'time_frame')) : { start: null, end: null }
        },

        () => {
          const id = checkProperty(response.result, 'id', null);
          this._getReceiptFile(id);
          Autoload.MainHelper.cust_fb_element('cc_i_re_a', 250);
        }
      );
      console.log(
        this.state.selectedFile,
        this.state.timeframe,
        this.state.receiptPeriodStart,
        this.state.receiptPeriodEnd,
        'selectedFile'
      );
    }
  }

  _getReceiptFile(receiptId) {
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.rm_api_base_url + 'attachment/' + receiptId,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_getReceiptFileResponse',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );
  }

  _getReceiptFileResponse(response) {
    console.log(response, 'edit reciept', this.props.record.file_name);
    if (response.status === true && response.statuscode === 401) {
      localStorage.clear();
      window.location.reload();
    }
    console.log('_getReceiptFileResponse: ', this.props.record);
    if (response.status === true && response.statuscode === 200 && response.result) {
      this.setState({ 
        editedFile: response.result, 
        selectedFile: this.props.record.file_name && [new File([this.props.record.file_name], this.props.record.fileName, {
          type: "application/pdf",
          lastModified: new Date().getTime()
        })]
      }, async ()=> {
        //this.props.record.fileName.includes('pdf') === false &&
        console.log('isPdfFile: ', await isPdfFile(this.props.record.file_name)); 
        if(await isPdfFile(this.props.record.file_name) === false){
          this.convertImageToPdf(this.props.record.file_name);
        }else{
          const selectedFileEncrypted = await this.isPdfEncrypted(this.props.record.file_name);
          console.log('selectedFileEncrypted: ', selectedFileEncrypted);
          this.setState({selectedFileEncrypted});
        }
        
      });
    }
  }

  resetForm = () => {
    this.setState({ ...this.initialState });
  };

  formatTimeframeToSend = () => {
    let frame = {};
    const {billingPeriods} = this.state;
    switch (this.props.utilityData ? this.props.utilityData.recordStatus : this.state.timeframe) {
      case 'last':
        frame = {
          start: dayjs(billingPeriods[1].startDate, billingPeriods[1].startDate.includes('T') ? 'YYYY-MM-DDT00:00:00' : 'DD.MM.YYYY').format('YYYY-MM-DD'),
          end: dayjs(billingPeriods[1].endDate, billingPeriods[1].startDate.includes('T') ? 'YYYY-MM-DDT00:00:00' : 'DD.MM.YYYY').format('YYYY-MM-DD')
        };
        break;
      case 'current':
        frame = {
          start: dayjs(billingPeriods[0].startDate, billingPeriods[1].startDate.includes('T') ? 'YYYY-MM-DDT00:00:00' : 'DD.MM.YYYY').format('YYYY-MM-DD'),
          end: dayjs(billingPeriods[0].endDate, billingPeriods[1].startDate.includes('T') ? 'YYYY-MM-DDT00:00:00' : 'DD.MM.YYYY').format('YYYY-MM-DD')
        };
        break;
      case 'custom':
        const { start } = this.state.customDate;
        // mm dd yy -- yyyy-mm-dd
        if (start != null) {
          let customStartDate = dayjs(this.state.customDate.start, 'DD.MM.YYYY').format('YYYY-MM-DD');
          let customEndDate = dayjs(this.state.customDate.end, 'DD.MM.YYYY').format('YYYY-MM-DD');
          frame = {
            start: customStartDate,
            end: customEndDate
          };
        } else {
          frame = {
            start: this.todayDateFrame(new Date()),
            end: this.todayDateFrame(new Date()),
          };
          this.setState({
            customDate: {
              start: this.todayDateFrame(new Date()),
              end: this.todayDateFrame(new Date()),
            },
          });
        }
        break;
      default:
        if(this.props.utilityData && this.props.utilityData.date) {
           let dateSplit= this.props.utilityData.date.split(' - ');
           frame = {
            start: dayjs(dateSplit[0], 'DD.MM.YYYY').format('YYYY-MM-DD'),
            end: dayjs(dateSplit[1], 'DD.MM.YYYY').format('YYYY-MM-DD'),
          };
        }
        break;
    }
    return frame;
  };

  todayDateFrame = (date) => {
    console.log(date, 'date dateToday');
    var dateMonth = date.getMonth() + 1;
    var dateDate = date.getDate();
    var dateToday = `${date.getFullYear()}-${dateMonth > 10 ? dateMonth : '0' + dateMonth}-${
      dateDate > 10 ? dateDate : '0' + dateDate
      }`;
    // console.log(dateToday,'dateToday')
    return dateToday;
  };
  formatFrameSend = (date) => {
    return date === '' ? new Date() : `${date.split('.')[2]}-${date.split('.')[0]}-${date.split('.')[1]}`;
  };
  formatFrame = (date) => {
    console.log(date, 'date formatFrame');
    return date === '' ? new Date() : `${date.split('.')[2]}-${date.split('.')[0]}-${date.split('.')[1]}`;
    // if (this.props.edit == true) {
    //   return date === '' ? new Date() : `${date.split('.')[2]}-${date.split('.')[0]}-${date.split('.')[1]}`;
    // } else return date === '' ? new Date() : `20${date.split('.')[2]}-${date.split('.')[0]}-${date.split('.')[1]}`;
  };

  setCustomDate = (timeFrame) => {
    if (timeFrame === '') {
      this.setState({ customDate: { start: null, end: null } });
    } else {
      let tempDate = timeFrame.split(' - ');
      this.setState({
        customDate: { start: dayjs(tempDate[0], 'YYYY-MM-DDT00:00:00').format('DD.MM.YYYY'), end: dayjs(tempDate[1], 'YYYY-MM-DDT00:00:00').format('DD.MM.YYYY') },
      });
      console.log(this.state.customDate, 'custom date to send ');
    }
  };

  setSelectedCost = (cost) => {
    let selectedCost;
    if (cost === '') {
      selectedCost = [];
    } else {
      selectedCost = this.state.costTypeOptions.filter((item) => cost === item.name);
    }
    return selectedCost;
  };

  setTimeFrame =  (frame) => {
    console.log(frame, '=====frame=======');
    if (frame === '') {
      return 'last';
    } else {
      const dates = frame.split(' - ');
      const periodStartDate = dates.length > 0 && dayjs(dates[0]).format('DD.MM.YYYY');
      const splitStartDate = periodStartDate.split('.');
      const periodEndDate = dates.length > 0 && dayjs(dates[1]).format('DD.MM.YYYY');
      const splitEndDate = periodEndDate.split('.');
      const {currentStartDate, currentEndDate, previousStartDate, previousEndDate} = this.state;
      console.log('setTimeFrame:', currentStartDate === periodStartDate, currentEndDate === periodEndDate);
      if (
        currentStartDate === periodStartDate && currentEndDate === periodEndDate
        // `${splitStartDate[1]}.${splitStartDate[2]}` === `${splitStartDate[1]}.${dayjs().get('year')}` &&
        // `${splitEndDate[1]}.${splitEndDate[2]}` === `${splitEndDate[1]}.${dayjs().get('year')}`
      ) {
        return 'current';
      }
      if (
        previousStartDate === periodStartDate && previousEndDate === periodEndDate
        // `${splitStartDate[1]}.${splitStartDate[2]}` === `${splitStartDate[1]}.${dayjs().get('year') - 1}` &&
        // `${splitEndDate[1]}.${splitEndDate[2]}` === `${splitEndDate[1]}.${dayjs().get('year') - 1}`
      ) {
        return 'last';
      }
      this.setCustomDate(frame);
      return 'custom';
      // switch (yearDifferenceMoment(periodStartDate)) {
      //   case 0:
      //     return 'current';
      //   case 1:
      //     return 'last';
      //   default:
      //     this.setCustomDate(frame);
      //     return 'custom';
      // }
    }
  };

  formatDate = (date) => {
    // // ;
    if (date === '') {
      return new Date();
    } else {
      let dateTemp = date.split('.');
      // date = date.replaceAll('.', '-')
      let d = new Date(dateTemp[2] + '-' + dateTemp[1] + '-' + dateTemp[0]);
      console.log('date format', d);
      return d;
      // let dateTemp = date.split('.');
      // return dateTemp[1] + '.' + dateTemp[0] + '.' + dateTemp[2];
    }
  };

  onDateChange = (field, date) => {
    console.log('onDateChange: ', date);
    this.setState({ [field]: date ? date : new Date() });
  };

  handleCheck = () => {
    this.setState({ UtilityBillFilter: !this.state.UtilityBillFilter, heatingCostType: !this.state.UtilityBillFilter === false ? null : this.state.heatingCostType, selectedCostType: !this.state.UtilityBillFilter === false ? [] : this.state.selectedCostType });
  };

  calculateVatUsingAmount =(value, vatPercent)=> {
    return value - (value / parseFloat(`${1 + (vatPercent / 100)}`));
  }

  onInputChange = (field, value) => {
    console.log('onInputChange: ', field, value);
    const {customVatType, selectedVatType} = this.state;
    if(value !== undefined){
      if(field === 'amount') {
        if(value){
          // Only calculate VAT if a VAT type is actively selected
          if (selectedVatType.length > 0) {
            let vatPercent = parseFloat(selectedVatType[0]?.label === 'anderer' ? customVatType : selectedVatType[0]?.label) || 0;
            let vatAmount = this.calculateVatUsingAmount(value, vatPercent);
            this.setState({amount: value, vatAmount: vatAmount, netAmount: value - vatAmount, firstTimeAmountNegative: false});
          } else {
            // If no VAT type is selected, don't populate VAT fields
            this.setState({amount: value, vatAmount: '', netAmount: '', firstTimeAmountNegative: false});
          }
        }else{
          this.setState({amount: value, vatAmount: '', netAmount: '', customVatType: null, selectedVatType: []});
        }
        
      } else if (field === 'netAmount') {
        // Net Amount drives the VAT Amount
        let safeValue = value || 0;
        let vatAmount = this.state.amount ? (this.state.amount - safeValue) : null;
        let vatPercent = this.state.amount && safeValue ? Math.abs((vatAmount / safeValue) * 100) : 0;
        
        this.setState({
          vatAmount: vatAmount !== null ? Math.round(vatAmount * 100) / 100 : '', 
          netAmount: value, 
          customVatType: vatPercent, 
          selectedVatType: [{label: 'anderer'}]
        });

      } else if (field === 'vatAmount') {
        // VAT Amount drives the Net Amount
        let safeValue = value || 0;
        let netAmount = this.state.amount ? (this.state.amount - safeValue) : null;
        let vatPercent = this.state.amount && netAmount ? Math.abs((safeValue / netAmount) * 100) : 0;
        
        this.setState({
          vatAmount: value, 
          netAmount: netAmount !== null ? Math.round(netAmount * 100) / 100 : '', 
          customVatType: vatPercent, 
          selectedVatType: [{label: 'anderer'}]
        });

      } else if(field === 'customVatType'){
        if (!value) {
          // If the user clears the custom VAT field completely using backspace
          this.setState({customVatType: '', vatAmount: '', netAmount: ''});
        } else {
          let vatPercent = parseFloat(value) || 0;
          let amount = this.state.amount;
          let vatAmount = amount ? amount - (amount / parseFloat(`${1 + (vatPercent / 100)}`)) : '';
          let netAmount = amount ? amount - vatAmount : '';
          this.setState({customVatType: value, amount, vatAmount, netAmount});
        }
        
      } else if(field === 'laborCost'){
        console.log('this.state.amount: ', this.state.amount);
        this.setState({ [field]: this.state.amount < 0 ? (value < 0 ? value : (value * -1)) : value });
        
      } else {
        this.setState({ [field]: value });
      }
    }
    
  };

  onCostTypeSelect = (selectedList, selectedItem) => {
    this.setState({ selectedCostType: [selectedItem], heatingCostType: selectedItem.systemCostTypeId === '941b0728-4a63-4d90-a80b-3de2bb80c0b1' ? this.state.heatingCostType : null });
  };
  onCostTypeRemove = (selectedList, removedItem) => {
    this.setState({ selectedCostType: [removedItem] });
  };

  onHeatingCostTypeSelect = (selectedList, selectedItem) => {
    console.log('onHeatingCostTypeSelect: ', selectedItem);
    
    this.setState({ heatingCostType: selectedItem });
  };
  onHeatingCostTypeRemove = (selectedList, removedItem) => {
    console.log('onHeatingCostTypeRemove: ', removedItem);
    
    this.setState({ heatingCostType: null });
  };

  onVatPercentageSelect = (selectedList, selectedItem) => {
    console.log('selectedItem: ', selectedItem);
    
    if(!selectedItem || selectedItem.label === this.state.selectedVatType[0]?.label){
      this.setState({ selectedVatType: [], vatAmount: '', netAmount: '' });  
    }else{
      if(this.state.amount){
        let vatPercent = parseFloat(selectedItem.label) || 0;
        let vatAmount = this.state.amount - (this.state.amount / parseFloat(1 + (vatPercent / 100)));
        let netAmount = this.state.amount - vatAmount;
        this.setState({vatAmount: vatAmount, netAmount: netAmount, selectedVatType: [selectedItem]});
      }else{
        this.setState({ selectedVatType: [selectedItem] });
      }
    }
  };

  onVatPercentageRemove = (selectedList, selectedItem) => {
    if(selectedItem?.label === this.state.selectedVatType[0]?.label){
      this.setState({ selectedVatType: [], vatAmount: '', netAmount: '' });  
    }else{
      if(this.state.amount){
        let vatPercent= parseInt(selectedItem?.label);
        let vatAmount = this.state.amount - (this.state.amount / parseFloat(1 + (vatPercent / 100)));
        let netAmount = this.state.amount - vatAmount;
        this.setState({vatAmount: vatAmount, netAmount: netAmount, selectedVatType: [selectedItem]});
      }else{
        this.setState({ selectedVatType: [selectedItem] });
      }
    }
  };

  onTaxCostTypeSelect = (selectedList, selectedItem) => {
    const {currentSubscription} = this.props;
    if(isStarterTier(currentSubscription)){
      this.setState({openPaidModalForTaxCostType: true});
    }else{
      this.setState({ selectedTaxCostType: [selectedItem] });  
    }
  };
  onTaxCostTypeRemove = (selectedList, removedItem) => {
    this.setState({ selectedTaxCostType: [removedItem] });
  };

  // isPdfEncrypted=(file)=>{
  //   let acceptedFileBlob = new Blob([file], { type: file.type });
  //   this.convertBlobToArrayBuffer(acceptedFileBlob).then(async (value)=> {
  //     try {
  //       await PDFDocument.load(value);  
  //       return false;
  //     } catch (error) {
  //       if(error.toString().includes('is encrypted')){
  //         console.log('isPdfEncrypted: ', error);
  //         showNotification({
  //           message: `${file.name} is encrypted. Cannot add or remove pages from this file.`,
  //           icon: <img src={RedCross} alt='red-cross'/>,
  //           autoClose: false,
  //           id: 'fileEncryptedError'
  //         });
  //         return true;
  //       }
  //       return false;
  //     }
  //   });
  // }

  isPdfEncrypted = async (file, showError=false, errorMessage='Die ausgewählte Datei ist ein geschütztes PDF und kann nicht hinzugefügt werden.') => {
    let acceptedFileBlob = new Blob([file], { type: file.type });
    try {
      const value = await this.convertBlobToArrayBuffer(acceptedFileBlob);
      try {
        await PDFDocument.load(value);  
        return false; // PDF is not encrypted
      } catch (error) {
        if (error.toString().includes('is encrypted')) {
          console.log('isPdfEncrypted: ', error);
          if(showError){
            showNotification({
              message: errorMessage,
              icon: <img src={RedCross} alt='red-cross' />,
              id: 'fileEncryptedError',
            });
          }
          return true; // PDF is encrypted
        }
        throw error; // Handle other errors if needed
      }
    } catch (error) {
      console.error('Error converting blob to array buffer:', error);
      throw error; // Rethrow the error if needed
    }
  };
  

  handleFileChange = async (acceptedFile, rejectedFile) => {
    console.log('handleFileChange: ', acceptedFile);

    const runConverIntoSingleFile=(selectedFileEncrypted=false, filterAcceptedFiles=[])=>{
      let {selectedFiles} = this.state;
      console.log('selectedFileEncrypted: ', selectedFileEncrypted);
      if(selectedFiles.length > 0){
        [filterAcceptedFiles ? 'filterAcceptedFiles' : 'acceptedFile'].map((af)=> selectedFiles.find((file)=> file.path === af.path) === undefined && selectedFiles.push(af));
        this.setState({selectedFiles, receiptName: acceptedFile[0].path.replace(/\.[^/.]+$/, '')},()=> {
          // callUploadForAiRecognition();
          if(selectedFileEncrypted === false){
            this.convertImagesToPdf();
          }else{
            this.setState({selectedFile: [acceptedFile[0]]}, ()=> this.uploadForAIRecognition());
          }
        });
      }else{
        this.setState({selectedFiles: filterAcceptedFiles.length > 0 ? filterAcceptedFiles : acceptedFile, receiptName: acceptedFile[0].path ? acceptedFile[0].path.replace(/\.[^/.]+$/, '') : acceptedFile[0].name.replace(/\.[^/.]+$/, '')}, ()=> {
          // callUploadForAiRecognition();
          if(selectedFileEncrypted === false){
            this.convertImagesToPdf();
          }else{
            this.setState({selectedFile: [acceptedFile[0]]}, ()=> this.uploadForAIRecognition());
          }
        });
      }

      if (this.props.edit) {
        this.setState({ editedFile: true });
      }
    }

    console.log('acceptedFile: ', acceptedFile);
    if (acceptedFile.length > 0) {
      if (acceptedFile.length === 1) {
        const selectedFileEncrypted = acceptedFile[0].type === 'application/pdf' ? await this.isPdfEncrypted(acceptedFile[0]) :  false;
        console.log('selectedFileEncrypted: ', selectedFileEncrypted);
        this.setState({selectedFileEncrypted}, ()=> setTimeout(() => {
          runConverIntoSingleFile(selectedFileEncrypted);
        }, 1000));
      }else{
        this.processFiles(acceptedFile, acceptedFile.length > 1).then((filteredFiles) => {
          console.log('Filtered Files: ', filteredFiles);
          runConverIntoSingleFile(false, filteredFiles);
        });
      }
      
    }
    if (rejectedFile.length > 0) {
      console.log('rejectedFile: ', rejectedFile);
      rejectedFile.map((file, index)=>
      file.errors.forEach((err) => {
        if (err.code === 'file-too-large') {
          this.setState({error: [...this.state.error, {fileName: file.file.name, message: 'Datei zu groß'}]}, ()=> 
          {
            if(rejectedFile.length === (index+1)){
              showNotification({
                message: 
                <Stack gap={2}>
                  <Group>Es ist ein Fehler aufgetreten. Das Dokument ist zu groß. Maximal erlaubte Dokumentgröße ist 100 MB.</Group>
                  {this.state.error.map((err)=> 
                    <Group wrap="nowrap" gap={2}>
                      <span style={{
                        // maxWidth: '290px', 
                        // overflowX: 'hidden', 
                        // textOverflow: 'ellipsis', 
                        // whiteSpace: 'nowrap'
                        }}>
                          {`Dateiname: ${err.fileName}`}
                      </span>
                      {/* <span>{'->'}</span>
                      <span style={{whiteSpace: 'nowrap', color: '#db1738'}}>{`${err.message}`}</span> */}
                    </Group>)}
                </Stack>,
                icon: <img src={RedCross} alt='red-cross'/>,
                id: 'fileSelectionError',
                autoClose: false
              });
              this.setState({error: []});
            }
          })
        }
        if (err.code === 'file-invalid-type') {
          this.setState({error: [...this.state.error, {fileName: file.file.name, message: 'Dateityp ungültig'}]}, ()=> 
          {
            if(rejectedFile.length === (index+1)){
              showNotification({
                message: 
                <Stack gap={2}>
                  {this.state.error.map((err)=> <Group wrap="nowrap" gap={2}><span style={{maxWidth: '290px', overflowX: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{`Dateiname: ${err.fileName}`}</span><span>{'->'}</span><span style={{whiteSpace: 'nowrap', color: '#db1738'}}>{`${err.message}`}</span></Group>)}
                </Stack>,
                icon: <img src={RedCross} alt='red-cross'/>,
                id: 'fileSelectionError',
                autoClose: false
              });
              this.setState({error: []});
            }
          });
        }
      }));
    } else {
      this.setState({ selectedFileErr: { state: false } });
    }

  };

  async convertImageToPdf(file){
    const {edit, record} = this.props;
    let files= [];
    console.log('convertImageToPdf: ', file);

    const conversionCode=(conversionFile= null)=>{
      const reader = new FileReader();
      if(conversionFile){
        reader.onload = async function (event) {
          console.log('if');
            const imgData = event.target.result;
            const img = new Image();
  
            // Create a new jsPDF instance
            img.onload = async function() {
              // Get the image dimensions
              const imgWidth = img.width;
              const imgHeight = img.height;
  
              // Calculate dimensions based on aspect ratio
              var doc = new jsPdf("p", "pt", 'a4');
              const pdfWidth = doc.internal.pageSize.getWidth();
              const pdfHeight = doc.internal.pageSize.getHeight();
  
              let width, height;
  
              // Calculate the scaling factor to fit the image within the page
              const widthScale = pdfWidth / imgWidth;
              const heightScale = pdfHeight / imgHeight;
              const scale = Math.min(widthScale, heightScale);
  
              width = imgWidth * scale;
              height = imgHeight * scale;
  
              // Center the image on the PDF
              const x = (pdfWidth - width) / 2;
              const y = (pdfHeight - height) / 2;
  
              // Add the image to the PDF with calculated dimensions
              doc.addImage(imgData, 'JPEG', x, y, width, height);
              // Add the image to the PDF
              // doc.addImage(imgData, 'JPEG', 10, 10, 180, 160);
              console.log('imgData: ', imgData);
              //doc.addImage(imgData, 'JPEG', 20, 20, 555, 802, undefined, 'FAST');
              await files.push(doc.output('arraybuffer'));
            };
            img.src = imgData;
        };
  
        reader.readAsDataURL(conversionFile);
      }
    }

    if(file){
      if(file.toString().includes('https') && edit){
        fetch(Autoload.Setting.rm_api_base_url + 'attachment/' + record?.id +'/download',
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': Autoload.Utils.getAuthToken()
        }
      })
      .then(response => {
          response.blob()
          .then(blob => {
            conversionCode(blob);
          })
        })
      }else{
        conversionCode(file);
      }
      
    }else{
      console.log('else');
      this.convertBlobToArrayBuffer(file).then((value)=> {
        files.push(value);
      });
    }

    console.log('files: ', files);

    // if(files.length > 0){
      setTimeout(() => {
        this.combineFiles(files, false);
      }, 1000);
    //}
  }

  async convertImagesToPdf(stopAiRecognition=false){
    const {selectedFiles}= this.state;
    let files= [];
    selectedFiles.map(async(file, index)=> {
      if(file.type.includes('image')){
        const reader = new FileReader();

        reader.onload = async function (event) {
            const imgData = event.target.result;
            const img = new Image();

            // Create a new jsPDF instance
            


            img.onload = async function() {
              // Get the image dimensions
              const imgWidth = img.width;
              const imgHeight = img.height;

              // Calculate dimensions based on aspect ratio
              var doc = new jsPdf("p", "pt", 'a4');
              const pdfWidth = doc.internal.pageSize.getWidth();
              const pdfHeight = doc.internal.pageSize.getHeight();

              let width, height;

              // Calculate the scaling factor to fit the image within the page
              const widthScale = pdfWidth / imgWidth;
              const heightScale = pdfHeight / imgHeight;
              const scale = Math.min(widthScale, heightScale);

              width = imgWidth * scale;
              height = imgHeight * scale;

              // Center the image on the PDF
              const x = (pdfWidth - width) / 2;
              const y = (pdfHeight - height) / 2;

              // Add the image to the PDF with calculated dimensions
              doc.addImage(imgData, 'JPEG', x, y, width, height);
              // Add the image to the PDF
              // doc.addImage(imgData, 'JPEG', 10, 10, 180, 160);
              console.log('imgData: ', imgData);
              //doc.addImage(imgData, 'JPEG', 20, 20, 555, 802, undefined, 'FAST');
              await files.push(doc.output('arraybuffer'));
            };
            img.src = imgData;
        };

        reader.readAsDataURL(file);
        // await html2canvas(file, {
        //   scale: 4
        // }).then(async(canvas) => {
        //   const imgData = canvas.toDataURL('image/png');
        //   var doc = new jsPdf("p", "pt", 'a4');
        //   console.log('imgData: ', imgData);
        //   doc.addImage(imgData, 'JPEG', 20, 20, 575, 822, undefined, 'FAST');
        //   await files.push(doc.output('arraybuffer'));
        // }).catch((e)=> console.error('convertImageToPdf: ', e));
      }else{
        this.convertBlobToArrayBuffer(file).then((value)=> {
          files.push(value);
        });
      }

      if(selectedFiles.length === (index + 1)){
        setTimeout(() => {
          this.combineFiles(files, stopAiRecognition);
        }, 1000);
      }
    });
    
    
  }

  async convertBlobToArrayBuffer(blob) {
    console.log('convertBlobToArrayBuffer', blob);
    const buf = await blob.arrayBuffer();
    return buf;
  }

  combineFiles=(files, stopAiRecognition=false)=>{
    console.log('combineFiles: ', this.props.record);
    const {selectedFiles} = this.state;
    const pdfBytes = this.mergePdfs(files);
    const fileName = this.props?.record?.fileName;
    const setState=(pdfFile)=> this.setState({selectedFile: [pdfFile], fileWasEdited: true}, ()=> {
      if(this.props.edit === false && !isStarterTier(this.props.currentSubscription)){
        stopAiRecognition == false && this.uploadForAIRecognition();
      }
    });
    pdfBytes.then(function(result) {
        var blob = new Blob([result], {type: "application/pdf"});
        const pdfFile = new File([blob], `${(selectedFiles[0]?.name ? selectedFiles[0]?.name : fileName) + (selectedFiles[0]?.name.includes('.pdf') ? '' : '.pdf')}`, {
          type: "application/pdf",
          lastModified: new Date().getTime()
        });
        console.log('uploadForAIRecognition: ', pdfFile);
        setState(pdfFile);
    })
    console.log('pdfBytes: ', pdfBytes);
  }

  async mergePdfs(pdfsToMerge) {
    try {
      console.log('mergePdfs', pdfsToMerge);
      const mergedPdf = await PDFDocument.create();

      const createInnerPromise = async (arrayBuffer) => {
        const pdf = await PDFDocument.load(arrayBuffer);
        return await mergedPdf.copyPages(pdf, pdf.getPageIndices());  
      };

      const outerPromise = pdfsToMerge.map((arrayBuffer) => {
        const innerPromise = createInnerPromise(arrayBuffer);
        return innerPromise;
      });

      const resultOuterPromise = await Promise.all(outerPromise);

      let count = 0;
      let totalPages = 0;
      resultOuterPromise.forEach((pageArray, i) => {
        pageArray.forEach((page, index) => {
          totalPages = totalPages + 1;
        })
      });
      resultOuterPromise.forEach((pageArray, i) => {
        pageArray.forEach((page) => {
          // const { width, height } = page.getSize();
          // page.drawText(`Seite ${count+1} von ${totalPages}`, {
          //   x: width - 67,
          //   y: height - 26,
          //   size: 6,
          //   color: rgb(0.5, 0.5, 0.5),
          // })
          mergedPdf.addPage(page);
          // count = count + 1;
        });
      });

      return (await mergedPdf.save()).buffer;
      
    } catch (error) {
      console.error('mergePdfs: ', error);
    }
  }

  removeImage = () => {
    console.log('remove');
    // this._deleteFile();
    this.setState({ selectedFile: null, selectedFiles: [], selectedFileEncrypted: false });
    if (this.props.edit) {
      this._deleteFile(this.props.record.id);
      // this.setState({ deletedFile: true });
    }
  };

  daysBetween = (date1, date2) => {
    // The number of milliseconds in one day
    const ONE_DAY = 1000 * 60 * 60 * 24;
    // Calculate the difference in milliseconds
    const differenceMs = Math.abs(date1 - date2);
    // Convert back to days and return
    return Math.round(differenceMs / ONE_DAY);
  };

  getBillingPeriods(periodType) {
    if(this.props.propertySelected && this.props.propertySelected.id !== undefined){
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.property_api_base_url +
        periodType +
        '?propertyId=' +
        this.props.propertySelected.id +
        '&offset=0&fetch=10',
        'GET',
        null,
        null,
        false,
        true,
        false,
        this,
        `_handle${periodType}Response`,
        null,
        false,
        '',
        {
          'Content-Type': 'application/json',
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    }
  }

  _handlecurrentBillingPeriodResponse(response) {
    console.log('_handlecurrentBillingPeriodResponse', response);
    if (response.status === true && response.statuscode === 401) {
      localStorage.clear();
      window.location.reload();
    }

    if (response.status === true && response.statuscode === 200) {
      response.result.period = `${lang.utility.text_current_billing_period} (${dayjs(response.result.startDate).format(
        'DD.MM.YYYY'
      )}-${dayjs(response.result.endDate).format('DD.MM.YYYY')})`;
      const billingPeriods = [...this.state.billingPeriods, response.result];
      this.currentBillingPeriodId = response.result.id;
      if (response.result.id === Autoload.Utils.getUrlParameterByName('billingId')) {
        this.setState({ currentBillingPeriod: { start: response.result.startDate, end: response.result.endDate } })
      }

      this.setState({ billingPeriods });
      this.getBillingPeriods('lastBillingPeriod');
    }else{
      loader(false);
    }
  }

  _handlelastBillingPeriodResponse(response) {
    if (response.status === true && response.statuscode === 401) {
      localStorage.clear();
      window.location.reload();
    }

    if (response.status === true && response.statuscode === 200) {
      // response.result.period = `Last billing period (${dayjs(response.result.startDate).format('DD.MM.YYYY')}-${dayjs(
      //   response.result.endDate
      // ).format('DD.MM.YYYY')})`;

      response.result.period = `${lang.utility.text_last_billing_period} (${dayjs(response.result.startDate).format(
        'DD.MM.YYYY'
      )}-${dayjs(response.result.endDate).format('DD.MM.YYYY')})`;
      const billingPeriods = [...this.state.billingPeriods, response.result];
      this.lastBillingPeriodId = response.result.id;

      if (response.result.id === Autoload.Utils.getUrlParameterByName('billingId')) {
        this.setState({ lastBillingPeriod: { start: response.result.startDate, end: response.result.endDate } })
      }
      this.setState({ billingPeriods });
      this.getBillingPeriods('billingPeriods');
    }
  }

  _handlebillingPeriodsResponse(response) {
    // console.log('_handlebillingPeriodsResponse', response);
    let billingPeriods = [...this.state.billingPeriods];
    if (response.status === true && response.statuscode === 401) {
      localStorage.clear();
      window.location.reload();
    }

    if (response.status === true && response.statuscode === 200) {
      response.result.map((billingPeriod) => {
        if (billingPeriod.id !== this.currentBillingPeriodId && billingPeriod.id !== this.lastBillingPeriodId) {
          billingPeriod.period = `${dayjs(billingPeriod.startDate).format('DD.MM.YYYY')}-${dayjs(
            billingPeriod.endDate
          ).format('DD.MM.YYYY')}`;
          billingPeriods = [...billingPeriods, billingPeriod];
        }
        return null;
      });
      this.setState({ billingPeriods }, () => {
        this.state.billingPeriods.map((billingPeriod) => {
          if (this.urlBillingId === billingPeriod.id) {
            this.setState({ meterDurationText: billingPeriod.period, currentMeter: billingPeriod.id });
          }
          return null;
        });
      });
    }
    this.formatDates(billingPeriods);
    this.getSystemHeatingCostTypes();
  }

  saveChanges = () => {
    var loader = document.getElementById('hello-housing-loader');
    loader.style.display = 'block';
    let frame = this.formatTimeframeToSend();
    const selectedCostTypes = this.state.selectedCostType;

    var selectedCostTypes_tem = [];

    if (selectedCostTypes != null) {
      selectedCostTypes.map((costType) => {
        selectedCostTypes_tem.push({ id: costType.id });
      });
    }
    const data = {
      id: this.props?.record?.id ? this.props?.record?.id : this.state.receiptId,
      name: this.state.receiptName,
      costs: this.state.amount,
      receiptDate: `${dayjs(this.state.date).format('YYYY-MM-DD')}T00:00:00`,
      utilityBillingRelevant: this.state.UtilityBillFilter ? true : false,
      receiptPeriodStart: this.props.billingRelevant || this.state.UtilityBillFilter ? frame.start : `${dayjs(this.state.date).format('YYYY-MM-DD')}T00:00:00`,
      receiptPeriodEnd: this.props.billingRelevant || this.state.UtilityBillFilter ? frame.end : `${dayjs(this.state.date).format('YYYY-MM-DD')}T00:00:00`,
      propertyId: this.props.propertySelected.id,
      selectedCostTypes: this.state.UtilityBillFilter ? selectedCostTypes_tem : [],
      isValidated: true,
      vatPercent: this.state.selectedVatType[0]?.label === 'anderer' ? parseFloat(this.state.customVatType) : parseInt(this.state.selectedVatType[0]?.label),
      vatAmount: checkProperty(this.state, 'vatAmount', null) ? this.state.vatAmount : null,
      netAmount: checkProperty(this.state, 'netAmount', null) ? this.state.netAmount : null,
      laborCost: this.state.laborCost,
      taxCostType: this.state.selectedTaxCostType[0]?.label,
      receiptNumber: this.state.receiptNumber,
      notes: this.state.notes,
      heatingCostType: this.state.selectedCostType[0]?.systemCostTypeId === '941b0728-4a63-4d90-a80b-3de2bb80c0b1' ? this.state.heatingCostType?.heatingCostTypeName : null
    };
    let btnelement = document.getElementById('receipt-add-edit-btns');

    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.api_base_url + config.receipts + this.props.record.id,
      'PUT',
      data,
      btnelement.children[1],
      false,
      true,
      false,
      this,
      'handleUpdateReceipt',
      { btnelement: btnelement, id: this.props.record.id, data },
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handleUpdateReceipt(response) {
    const {transactionAssigmentScreen, receiptAssignment} = this.props;
    const {fileWasEdited} = this.state;
    var loader = document.getElementById('hello-housing-loader');
    loader.style.display = 'none';

    const close=()=>{
      this.props.setRefreshReceiptDocumentsData(true);
      var loader = document.getElementById('hello-housing-loader');
      loader.style.display = 'none';
      this.resetForm();
      this.props.toggle();
    }
    if (response.status === true) {
      if(transactionAssigmentScreen || receiptAssignment){
        this.props.onEditSave(response.other.data);
      }

      if(this.state.selectedFile && this.state.selectedFile.length > 0){
        showNotification({
          message: 'Die Änderungen wurden übernommen.',
          icon: <img src={GreenTick} alt='green-tick'/>,
        });
      }
      if (!this.state.editedFile) {
        this.resetForm();
        if(this.props.parent && window.location.href.includes('accounting/anlage-v')){
          this.props.getReceipts();
        }else if(typeof this.props?.parent?.bind_list_receipt_data === "function"){
          this.props.parent.bind_list_receipt_data(true);
        }
        this.props.toggle();
        return;
      }
      if(fileWasEdited){
        if(window.location.pathname.includes('/receipt')){
          if(this.state.selectedFile && this.state.selectedFile.length > 0 && !this.state.selectedFile.includes('https')){
            console.log('test: ', this.state.selectedFile);
            this.props.showFirstRowLoader();
            this.props.setAddReceiptModal(true);
            this.props.setReceiptCurrentId(response.other.id);
            this.props.setReceiptFiles([this.state.selectedFile[0]]);
            console.log('toggle');
            setTimeout(() => {
              var elem = document.getElementById("uploadReceiptDocs");
              if (elem && typeof elem.onclick === "function") {
                  elem.onclick.apply(elem);
              }
              var loader = document.getElementById('hello-housing-loader');
              if (loader) loader.style.display = 'none';
              this.resetForm();
              this.props.toggle();
            }, 150);
          }else{
            close();
          }
        }else{
          const data = new FormData();
          this.state.selectedFile && this.state.selectedFile.length > 0 && data.append('files', this.state.selectedFile[0]);
          Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.rm_api_base_url + 'upload/' + response.other.id,
            'PUT',
            data,
            response.other.btnelement.children[1],
            false,
            true,
            false,
            this,
            'handleaddReceiptFileUpload',
            {},
            false,
            '',
            {
              'Content-Type': 'multipart/form-data',
              Authorization: Autoload.Utils.getAuthToken(),
            }
          );
        }
      }else{
        close();
      }
      
    } else {
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        //message: 'Die Änderungen wurden gespeichert.',
        icon: <img src={RedCross} alt='red-tick'/>
      });
    }
  }

  uploadForAIRecognitionLegacy = ()=> {
    console.log('uploadForAIRecognitionLegacy: ', this.state.selectedFile);
    this.setState({aiLoader: true});
    const data = new FormData();
    this.state.selectedFile && this.state.selectedFile.length > 0 && data.append('files', this.state.selectedFile[0]);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.rm_api_basic_base_url + 'Invoices/analyze',
      'POST',
      data,
      null,
      false,
      true,
      false,
      this,
      'handleUploadForAIRecognition',
      {},
      false,
      '',
      {
        'Content-Type': 'multipart/form-data',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );
  }

  handleUploadForAIRecognitionLegacy(response){
    if (response.status === true && response.statuscode === 200) {
      console.log('handleUploadForAIRecognitionLegacy: ', this.state.currentStartDate, this.state.currentEndDate, this.state.previousStartDate, this.state.previousEndDate, dayjs(response.result.serviceStartDate).format('DD.MM.YYYY'));
      let vatAmount = response.result.totalTax ? 
        response.result.totalTax 
        : 
        ((response.result.taxRate && response.result.invoiceTotal) ? this.calculateVatUsingAmount(response.result.invoiceTotal, response.result.taxRate) : null);
      let netAmount = response.result.invoiceTotal && vatAmount ? response.result.invoiceTotal - vatAmount : null;
      let timeframe = (response.result.serviceStartDate && response.result.serviceEndDate) ?
        dayjs(response.result.serviceStartDate) >= (dayjs(this.state.currentStartDate, 'DD.MM.YYYY')) && dayjs(response.result.serviceEndDate) <= (dayjs(this.state.currentEndDate, 'DD.MM.YYYY')) ? 'current'
        :
        dayjs(response.result.serviceStartDate) >= (dayjs(this.state.previousStartDate, 'DD.MM.YYYY')) && dayjs(response.result.serviceEndDate).format('DD.MM.YYYY') <= (dayjs(this.state.previousEndDate, 'DD.MM.YYYY')) ? 'last'
        : 
        'custom'
        : 
        'current';
      
      this.setState({
        amount: response.result.invoiceTotal ? response.result.invoiceTotal : this.state.amount, 
        selectedVatType: response.result.taxRate && (response.result.taxRate === 7 || response.result.taxRate === 19) ? [{label: `${response.result.taxRate},00 %`}] : [],
        customVatType: response.result.taxRate && (response.result.taxRate !== 7 && response.result.taxRate !== 19) ? response.result.taxRate : null,
        vatAmount,
        netAmount,
        date: response.result.invoiceDate ? response.result.invoiceDate : new Date(),
        receiptName: response.result.vendorName ? response.result.vendorName : this.state.receiptName,
        timeframe,
        UtilityBillFilter: response.result.serviceStartDate && response.result.serviceEndDate,
        customDate: timeframe === 'custom' && {start: response.result.serviceStartDate ? dayjs(response.result.serviceStartDate).format('DD.MM.YYYY') : dayjs().format('DD.MM.YYYY'), end: response.result.serviceEndDate ? dayjs(response.result.serviceEndDate).format('DD.MM.YYYY') : dayjs().format('DD.MM.YYYY')},
        receiptNumber: response.result.invoiceId
      })
    }
    this.setState({aiLoader: false});
  }

  uploadForAIRecognition= () => {
    console.log('uploadForAIRecognition: ', this.state.selectedFile);
    this.setState({aiLoader: true});
    const data = new FormData();
    this.state.selectedFile && this.state.selectedFile.length > 0 && data.append('file', this.state.selectedFile[0]);
    data.append('encryptedToken', this.props.profileData?.auth?.encryptedToken);
    data.append('propertyId', this.props?.propertySelected?.id);
    data.append('userId', this.props.profileData?.id);
    data.append('accountId', this.props.accountData?.accountId);
    Autoload.HttpRequestAxios.HttpRequest(
      (window.location.href.includes('app.')
      ? 'https://app.hellohousing.de/api/bot-api'
      : window.location.href.includes('dev.') ? 'https://dev.hellohousing.de/api/bot-api' : 'http://localhost:3001') + "/extractReceipt",
      'POST',
      data,
      null,
      false,
      true,
      false,
      this,
      'handleUploadForAIRecognition',
      {},
      false,
      '',
      {
        'Content-Type': 'multipart/form-data',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );
  }

  handleUploadForAIRecognition(response){
    if (response.status === 200) {
      console.log('handleUploadForAIRecognition: ', this.state.currentStartDate, this.state.currentEndDate, this.state.previousStartDate, this.state.previousEndDate, dayjs(response.result.receiptPeriodStart).format('DD.MM.YYYY'));
      let vatAmount = response.result.vatAmount ? 
        response.result.vatAmount 
        : 
        ((response.result.vatPercent && response.result.cost) ? this.calculateVatUsingAmount(response.result.cost, response.result.vatPercent) : null);
      let netAmount = response.result.netAmount;
      let timeframe = (response.result.receiptPeriodStart && response.result.receiptPeriodEnd) ?
        dayjs(response.result.receiptPeriodStart) >= (dayjs(this.state.currentStartDate, 'DD.MM.YYYY')) && dayjs(response.result.receiptPeriodEnd) <= (dayjs(this.state.currentEndDate, 'DD.MM.YYYY')) ? 'current'
        :
        dayjs(response.result.receiptPeriodStart) >= (dayjs(this.state.previousStartDate, 'DD.MM.YYYY')) && dayjs(response.result.receiptPeriodEnd).format('DD.MM.YYYY') <= (dayjs(this.state.previousEndDate, 'DD.MM.YYYY')) ? 'last'
        : 
        'custom'
        : 
        'current';

      // find() is undefined when the extraction proposes no cost type (or one not used in receipts);
      // keep the list empty then rather than [undefined], which addReceipt can't map over
      const suggestedCostType = this.state.costTypeOptions.find((option)=> option.id === response?.result?.selectedCostTypeId);
      let selectedCostType = suggestedCostType ? [suggestedCostType] : [];
      
      this.setState({
        amount: response.result.cost || this.state.amount,
        // the sign is explicit now, so the amount field must not negate it again on its next change
        firstTimeAmountNegative: response.result.cost ? false : this.state.firstTimeAmountNegative,
        selectedVatType: response.result.vatPercent ? (response.result.vatPercent === 7 || response.result.vatPercent === 19) ? [{label: `${response.result.vatPercent},00 %`}] : [{label: 'anderer'}] : [],
        customVatType: response.result.vatPercent && (response.result.vatPercent !== 7 && response.result.vatPercent !== 19) ? response.result.vatPercent : null,
        vatAmount,
        netAmount,
        date: response.result.receiptDate ? response.result.receiptDate : new Date(),
        receiptName: response.result.name ? response.result.name : this.state.receiptName,
        timeframe,
        UtilityBillFilter: response.result.utilityBillingRelevant,//response.result.receiptPeriodStart && response.result.receiptPeriodEnd,
        customDate: timeframe === 'custom' && {start: response.result.receiptPeriodStart ? dayjs(response.result.receiptPeriodStart).format('DD.MM.YYYY') : dayjs().format('DD.MM.YYYY'), end: response.result.receiptPeriodEnd ? dayjs(response.result.receiptPeriodEnd).format('DD.MM.YYYY') : dayjs().format('DD.MM.YYYY')},
        receiptNumber: response.result.receiptNumber,
        laborCost: response.result?.laborCost,
        selectedTaxCostType: [{label: response.result?.taxCostType}],
        selectedCostType,
        notes: response.result?.notes,
        heatingCostType: this.state.systemHeatingCostTypes.find((systemHeatingCostType)=> systemHeatingCostType?.heatingCostTypeName === response.result?.heatingCostType) || null
      })

    } else if (response.statuscode === 402) {
      showNotification({
        message: response.signal === 'call_opensubscriptionmodal' ?
          'Das KI-Guthaben Ihres Test-Abonnements ist aufgebraucht. Nach dem Start eines Bezahl-Abonnements stehen Ihnen flexibel weiteres KI-Guthaben zur Verfügung.'
          :
          (response.message || 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.'),
        icon: <img src={RedCross} alt='red-tick'/>
      });
    }
    this.setState({aiLoader: false});
  }

  _deleteFile(receiptID) {
    console.log('delete receipt file');
    var loader = document.getElementById('hello-housing-loader');
    loader.style.display = 'block';
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.rm_api_base_url + 'attachment/' + receiptID,
      'DELETE',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleDeleteFileResponse',
      {},
      false,
      '',
      {
        'Content-Type': 'multipart/form-data',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  _handleDeleteFileResponse(response) {
    if (response.status) {
      this.setState({ deletedFile: true });
      this.props.refreshData();
    }

    var loader = document.getElementById('hello-housing-loader');
    loader.style.display = 'none';
  }

  addReceipt = () => {
    var loader = document.getElementById('hello-housing-loader');
    loader.style.display = 'block';
    const btnelement = document.getElementById('receipt-add-edit-btns');
    const frame = this.formatTimeframeToSend();
    var selectedCostTypes_tem = [];
    const selectedCostTypes = this.props.selectedCostType ? this.props.selectedCostType : this.state.selectedCostType;
    const heatingCostType = this.props.heatingCostType ? this.props.heatingCostType : (this.state.selectedCostType[0]?.systemCostTypeId === '941b0728-4a63-4d90-a80b-3de2bb80c0b1' ? this.state.heatingCostType?.heatingCostTypeName : null);
    if (selectedCostTypes != null) {
      selectedCostTypes.map((costType) => {
        selectedCostTypes_tem.push({ id: costType.id });
      });
    }
    
    const data = JSON.stringify({
      id: null,
      name: this.state.receiptName,
      receiptDate: `${dayjs(this.state.date).format('YYYY-MM-DD')}T00:00:00`,
      date: `${dayjs(this.state.date).format('YYYY-MM-DD')}T00:00:00`,
      costs: this.state.amount,//Autoload.MainHelper.ConverterLocaleNumber(this.state.amount, 'de'),
      cost: this.state.amount,//Autoload.MainHelper.ConverterLocaleNumber(this.state.amount, 'de'),
      utilityBillingRelevant: this.props.billingRelevant ? true : this.state.UtilityBillFilter ? true : false,
      receiptPeriodStart: this.props.billingRelevant || this.state.UtilityBillFilter ? `${frame.start}` : `${dayjs(this.state.date).format('YYYY-MM-DD')}T00:00:00`,
      receiptPeriodEnd: this.props.billingRelevant || this.state.UtilityBillFilter ? `${frame.end}` : `${dayjs(this.state.date).format('YYYY-MM-DD')}T00:00:00`,
      propertyId: this.props.propertySelected.id,
      selectedCostTypes: selectedCostTypes_tem,
      //New attributes
      vatPercent: this.state.selectedVatType[0]?.label === 'anderer' ? parseFloat(this.state.customVatType) : parseInt(this.state.selectedVatType[0]?.label),
      vatAmount: checkProperty(this.state, 'vatAmount', null) ? this.state.vatAmount : null,
      netAmount: checkProperty(this.state, 'netAmount', null) ? this.state.netAmount : null,
      laborCost: this.state.laborCost,
      taxCostType: this.state.selectedTaxCostType[0]?.label,
      receiptNumber: this.state.receiptNumber,
      notes: this.state.notes,
      heatingCostType
    });
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.rm_api_base_url + 'create',
      'POST',
      data,
      btnelement.children[1],
      false,
      true,
      false,
      this,
      'handleaddReceipt',
      { btnelement: btnelement, data },
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handleaddReceipt(response) {
    const {transactionAssigment=null} = this.props;
    var loader = document.getElementById('hello-housing-loader');
    if(this.state.selectedFile === null ){
      loader.style.display = 'none';
    }
    window.Intercom("update", {
      'Receipt Created': true
    });
    window.Intercom('trackEvent', 'receipt-created');
    if (response.status === true) {
      
      console.log('handleaddReceipt1:', response);
      if (this.state.selectedFile === null) {
        showNotification({
          //title: 'Erfolgreich!',
          message: 'Der Beleg wurde hinzugefügt.',
          icon: <img src={GreenTick} alt='green-tick'/>,
        });
        this.resetForm();
        //dashbaord redirect else same
        if(transactionAssigment === null &&  window.location.href.includes('accounting/anlage-v')){
          this.props.getReceipts();
        }else if(typeof this.props?.parent?.bind_list_receipt_data === "function"){
          this.props.parent.bind_list_receipt_data(true);
        }
        (transactionAssigment === null && this.props.receiptPage === true) && this.props.checkfilterToggleBtn(false);
        this.props.toggle({...JSON.parse(response.other.data), id: response.result});
        (transactionAssigment === null && this.props.onCreateReceiptSelect) && this.props.onCreateReceiptSelect(response.result);
        //  window.location.reload();
        return;
      }
      if(window.location.href.includes('/receipt')){
        this.props.showFirstRowLoader();
        this.props.setAddReceiptModal(true); 
        this.props.setReceiptCurrentId(response.result);
        this.props.setReceiptFiles([this.state.selectedFile[0]]);
        
        // ADD SETTIMEOUT TO WAIT FOR REACT 18 BATCHED RENDER
        setTimeout(() => {
          var elem = document.getElementById("uploadReceiptDocs");
          
          if (elem && typeof elem.onclick === "function") {
              elem.onclick.apply(elem);
          } else if (elem) {
              elem.click(); // Fallback trigger
          }
          
          var loader = document.getElementById('hello-housing-loader');
          if (loader) loader.style.display = 'none';
          
          this.resetForm();
          this.props.toggle();
        }, 150); // 150ms gives React enough time to mount the new props in Main.js
      }else{
        const data = new FormData();
        data.append('files', this.state.selectedFile[0]);
        Autoload.HttpRequestAxios.HttpRequest(
          Autoload.Setting.rm_api_base_url + 'upload/' + response.result,
          'PUT',
          data,
          response.other.btnelement.children[1],
          false,
          true,
          false,
          this,
          'handleaddReceiptFileUpload',
          {data: response.other.data, id: response.result},
          false,
          '',
          {
            'Content-Type': 'multipart/form-data',
            Authorization: Autoload.Utils.getAuthToken(),
          }
        );
      }
    } else {
      // this.resetForm();
      // window.location.reload();
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        //message: 'Die Änderungen wurden gespeichert.',
        icon: <img src={RedCross} alt='red-tick'/>
      });
    }
  }

  handleaddReceiptFileUpload(response) {
    const {noParentAllListAvailable=false, transactionAssigment=null} = this.props;

    var loader = document.getElementById('hello-housing-loader');
    loader.style.display = 'none';
    this.resetForm();

    if(noParentAllListAvailable === false && transactionAssigment === null){
      if(window.location.href.includes('accounting/anlage-v')){
        this.props.getReceipts();
      }else if (transactionAssigment === null && this.props.onCreateReceiptSelect){
        this.props.onCreateReceiptSelect(response.other.id);
      }else if(typeof this.props?.parent?.bind_list_receipt_data === "function"){
        this.props.parent.bind_list_receipt_data(true);
      }
    }else if(transactionAssigment === null){
      this.props.refreshData();
    }
    this.props.toggle({...JSON.parse(response.other.data), id: response.other.id});
  }
  
  
  // Very simple form validation with feedback
  validateFormData = () => {
    
    // Empty recipe title
    if (!this.state.receiptName) { 
      this.setState({ errors: { title: "Das Ausfüllen dieses Feldes ist erforderlich" } });
      return false;
    } else {
      this.setState({ errors: { title: null } });
    }

    // Empty recipe amount
    if (!this.state.amount) {
      this.setState({ errors: { amount: "Das Ausfüllen dieses Feldes ist erforderlich" } });
      return false;
    } else {
      this.setState({ errors: { amount: null } });
    }

    // Invalid recipe amount
    if (this.state.amount > 100000) {
      this.setState({ errors: { amount: "Ungültiger Betrag" } });
      return false;
    } else {
      this.setState({ errors: { amount: null } });
    }

    if (this.state.UtilityBillFilter) {
      if (this.state.selectedCostType.length === 0) {
        this.setState({ errors: { costType: "Das Ausfüllen dieses Feldes ist erforderlich" } });
        return false;
      } else {
        this.setState({ errors: { costType: null } });

        if(this.state.selectedCostType[0]?.systemCostTypeId === '941b0728-4a63-4d90-a80b-3de2bb80c0b1'){
          if(!this.state.heatingCostType){
            this.setState({ errors: { heatigCostType: "Das Ausfüllen dieses Feldes ist erforderlich" } });
            return false;
          }else{
            this.setState({ errors: { heatigCostType: null } });
          }
        }
      }
    }
    
    return true;
    
  }

  // Save Receipt
  handleSubmit = (e) => {
    e.preventDefault();
    
    const isValid = this.validateFormData();
    
    if (isValid) {
      if (this.props.edit) {
        this.saveChanges();
      } else {
        this.addReceipt();
      }
    }
  };
  //08.23.21 --> yy mm dd (js)
  formatReceiptDate = (date) => {
    console.log(date, 'date');
    return date === '' ? new Date() 
    : (dayjs(date, 'DD.MM.YY', true).isValid() ? dayjs(date, 'DD.MM.YY').format('DD.MM.YYYY') 
    : dayjs(date, 'DD.MM.YYYY').format('DD.MM.YYYY'));
  };

  renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {/* Time frame which the bill covers. */}
      {lang.newKeys.text_receipt_period_tooltip}
    </Tooltip>
  );

  handleEnterKeyPress = (e) => {
    if (e.charCode == 13) {
      e.preventDefault();
      this.handleSubmit(e);
    }
  };

  getFileExtension = (file)=>{
    if (file) {
      let re = /(?:\.([^.]+))?$/;
      var extension = re.exec(file)[1];
      extension = extension && extension.split('?')[0];
      console.log('getFileExtension: ', file);
      if (extension === 'jpg' || extension === 'png' || extension === 'jpeg') {
        return 'img';
      } else if (typeof(file) === 'object') {
        return 'pdf';
      }
    }
  }

  removeFile = (selected) => {
    console.log('removeFile: ', selected);
    let {selectedFiles} = this.state;
    selectedFiles = selectedFiles.filter((file)=> selected.path !== file.path);
    this.setState({selectedFiles});
  };

  removePageFromExistingPDF = async (pdfBytes, pageToRemove) => {
    // Load an existing PDF file into the PDFDocument
    const pdfDoc = await PDFDocument.load(pdfBytes);
  
    // Get the total number of pages in the document
    const totalPages = pdfDoc.getPageCount();
  
    console.log('totalPages: ', totalPages);
    if(totalPages > 1){
      // Check if the pageToRemove is within range
      if (pageToRemove >= 0 && pageToRemove < totalPages) {
        // Remove the specified page (0-indexed)
        pdfDoc.removePage(pageToRemove);
      } else {
        console.error("Invalid page number to remove.");
        return null;
      }

      // Serialize the PDFDocument to bytes (array of uint8)
      const newPdfBytes = await pdfDoc.save();

      // Return the modified PDF bytes (you can download it or show it in the UI)
      return newPdfBytes;
    }else{
      this.setState({selectedFile: null, selectedFiles: []});
      return null;
    }
    
  };

  removePageFromPDF = (pageToRemove) => {
    console.log('pageToRemove: ', pageToRemove);
    const {selectedFile, selectedFiles} = this.state;
    const {edit, record} = this.props;

    this.convertBlobToArrayBuffer(selectedFile[0]).then(async (pdfBytes)=> {
      const newPdfBytes = await this.removePageFromExistingPDF(pdfBytes, pageToRemove-1);

      if (newPdfBytes) {
        // Create a Blob and download the modified PDF
        const blob = new Blob([newPdfBytes], { type: 'application/pdf' });
        const pdfFile = new File([blob], `${edit ? record.fileName.includes('pdf') ? record.fileName : `${record.fileName}.pdf` : (selectedFiles[0]?.name+ (selectedFiles[0]?.name.includes('.pdf') ? '' : '.pdf'))}`, {
          type: "application/pdf",
          lastModified: new Date().getTime()
        });
        this.setState({selectedFile: [pdfFile], fileWasEdited: true}, ()=> 
          showNotification({
            message: 'Belegseite entfernt',
            icon: <img src={RedCross} alt='red-cross'/>,
            id: 'removePdfPage'
          })
        );
      }
    });

    
  };

  processFiles = async (files, multipleFiles=false) => {
    const processedFiles = await Promise.all(
      files.map(async (file) => {
        if (file.type === 'application/pdf') {
          const isPdfEncrypted = await this.isPdfEncrypted(file, true, multipleFiles ? 'Die ausgewählten Dateien enthalten geschützte PDF-Dokumente. Diese konnten nicht hinzugefügt werden. Sie können geschützte PDF-Dokumente einzeln hochladen.' : 'Die ausgewählte Datei ist ein geschütztes PDF und kann nicht hinzugefügt werden.');
          console.log('handleFileAdd: ', isPdfEncrypted);
          return isPdfEncrypted ? null : file; // Return null for encrypted files
        } else {
          return file; // Keep non-PDF files
        }
      })
    );
  
    // Filter out null values (encrypted files)
    return processedFiles.filter((file) => file !== null);
  };
  

  handleFileAdd= async (e)=>{
    const {selectedFile} = this.state;
    let {selectedFiles} = this.state;
    const {edit, record} = this.props;
    console.log('handleFileAdd: ', e.target.files);
    if (e.target.files.length > 0) {
      let acceptedFiles = Array.from(e.target.files);
      this.processFiles(acceptedFiles, acceptedFiles.length > 1).then((filteredFiles) => {
        console.log('Filtered Files: ', filteredFiles);
        acceptedFiles = filteredFiles; // Update acceptedFiles with the filtered list
        console.log('handleFileAdd: ', acceptedFiles);
        if(acceptedFiles.length > 0){
          const unprocessedFiles = acceptedFiles.filter(file => !file.type.startsWith('image/'));
          const processedFiles = acceptedFiles.filter(file => file.type.startsWith('image/')) // Filter to only process image files
          .map(file => 
            new Promise((resolve) => {
              const reader = new FileReader();
              reader.onload = function(event) {
                const img = new Image();
                img.src = event.target.result;
    
                img.onload = function() {
                  // Get EXIF orientation data
                  EXIF.getData(img, function() {
                    const orientation = EXIF.getTag(this, "Orientation") || 1;
    
                    console.log('orientation: ', orientation);
    
                    // Create a canvas to apply orientation correction
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");
    
                    let width = img.width;
                    let height = img.height;
    
                    // Adjust canvas size based on orientation
                    if (orientation === 6 || orientation === 8) {
                      canvas.width = width;
                      canvas.height = height;
                    } else {
                      canvas.width = width;
                      canvas.height = height;
                    }
    
                    // Apply the necessary rotation based on the EXIF orientation
                    switch (orientation) {
                      case 6: // 90 degrees
                        // ctx.rotate(90 * Math.PI / 180);
                        // ctx.translate(0, -height);
                        
                        break;
                      case 8: // -90 degrees
                        // ctx.rotate(-90 * Math.PI / 180);
                        // ctx.translate(-width, 0);
                        break;
                      case 3: // 180 degrees
                        ctx.rotate(Math.PI);
                        ctx.translate(-width, -height);
                        break;
                      // case 2: ctx.translate(width, 0);     ctx.scale(-1,1); break;
                      // case 3: ctx.translate(width,height); ctx.rotate(Math.PI); break;
                      // case 4: ctx.translate(0,height);     ctx.scale(1,-1); break;
                      // case 5: ctx.rotate(0.5 * Math.PI);   ctx.scale(1,-1); break;
                      // case 6: ctx.rotate(0.5 * Math.PI);   ctx.translate(0,-height); break;
                      // case 7: ctx.rotate(0.5 * Math.PI);   ctx.translate(width,-height); ctx.scale(-1,1); break;
                      // case 8: ctx.rotate(-0.5 * Math.PI);  ctx.translate(-width,0); break;
                      default: // Normal orientation
                        break;
                    }
    
                    // Draw the corrected image onto the canvas
                    ctx.drawImage(img, 0, 0, width, height);
    
                    // Convert the canvas to a data URL with corrected orientation
                    const correctedImageData = canvas.toDataURL("image/jpeg");
    
                    // Convert base64 image data to Blob
                    const byteString = atob(correctedImageData.split(',')[1]); // Remove the base64 prefix and decode
                    const byteArray = new Uint8Array(byteString.length);
    
                    // Populate the byteArray with the decoded bytes
                    for (let i = 0; i < byteString.length; i++) {
                      byteArray[i] = byteString.charCodeAt(i);
                    }
    
                    // Create a Blob from the byteArray
                    const imageBlob = new Blob([byteArray], { type: 'image/jpeg' });
    
                    // Convert the Blob to a File
                    const correctedFile = (orientation === 3 || orientation === 6 || orientation === 8) ? new File([imageBlob], file.name, {
                      type: 'image/jpeg',
                      lastModified: new Date().getTime(),
                    })
                    : file;
    
                    // Resolve the promise with the corrected image data
                    resolve(
                      //originalFile: file,
                      correctedFile
                    );
                  });
                };
              };
              reader.readAsDataURL(file);
            })
          );
    
          Promise.all(processedFiles).then((files) => {
            selectedFiles= [selectedFile[0], ...files, ...unprocessedFiles];
            this.setState({selectedFiles},()=> {
              this.convertImagesToPdf(true);
              showNotification({
                message: 'Belegseite(n) hinzugefügt',
                icon: <img src={GreenTick} alt='green-tick'/>,
                id: 'addPdfPage'
              });
            });
          });
        }
      });
      
    }
  }

  renderRestrictedFunctionMessage=()=>{
    showNotification({
      message: 'Die bereitgestellte PDF-Datei ist geschützt. Es können keine Änderungen vorgenommen werden.',
      icon: <img src={RedCross} alt='red-cross'/>,
      id: 'restrictedFileEdit'
    });
  }

  deleteSystemHeatingCostType=(option)=>{
    console.log('deleteSystemHeatingCostType: ', option);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'heatingCosts?propertyId=' + this.props.propertySelected.id + '&heatingCostTypeName=' + option?.heatingCostTypeName,
      'DELETE',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleDeleteSystemHeatingCostType',
      null,
      false,
      '',
      {
        'Content-Type': 'multipart/form-data',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleDeleteSystemHeatingCostType(response){
    if(response.status && response.statuscode === 200){
      showNotification({
        message: 'Die Kostenart wurde gelöscht.',
        icon: <img src={RedTick} alt='red-tick'/>,
        id: 'deleteHeatingCostType'
      });
      this.getSystemHeatingCostTypes();
    } else {
      showNotification({
        message: 'Diese Kostenart wird noch verwendet und konnte nicht gelöscht werden.',
        icon: <img src={RedCross} alt='red-cross'/>,
      });
    }
  }

  createHeatingCostType=(heatingCostTypeName)=>{
    const {propertySelected} = this.props;
    let payload = {
      heatingCostType: heatingCostTypeName,
      heatingCostTypeName,
      heatingCost: 0,
      systemHeatingCostTypeId: null,
      displayOrder: 0,
      propertyId: propertySelected.id,
      utilityBillingId: null
    };
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'heatingCosts',//?propertyId=' + propertySelected.id,
      'POST',
      payload,
      null,
      false,
      true,
      false,
      this,
      'handleCreateHeatingCostType',
      {payload},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleCreateHeatingCostType(response){
    if(response.status && response.statuscode === 200){
      if(response?.other?.payload){
        this.setState({heatingCostType: {...response.other.payload, id: response.other.payload.heatingCostTypeName}},()=> this.getSystemHeatingCostTypes(true));
      }
    }
  }

  renderHeatingCostAllocatorSection=()=>{
    const {systemHeatingCostTypes, heatingCostType} = this.state;
    return (
      <Row>
        <Col xs={12}>
          <Form.Group>
            <Form.Label> {'Heizkostenart'} *</Form.Label>
            <SelectDropdown
              options={systemHeatingCostTypes.sort((a, b) => a.heatingCostTypeName.localeCompare(b.heatingCostTypeName))} // Options to display in the dropdown
              selectedValue={heatingCostType} // Preselected value to persist in dropdown
              onSelect={this.onHeatingCostTypeSelect} // Function will trigger on select event
              onRemove={this.onHeatingCostTypeRemove} // Function will trigger on remove event
              displayValue="heatingCostTypeName"
              placeholder={lang.newKeys.text_select}
              deleteOptionList={true}
              deleteOptionConditions={[{key: 'isSystemHeatingCostType', value: false}, {key: 'hasReferencedUtilityBilling', value: (null || false)}]}
              deleteOption={(option)=> this.deleteSystemHeatingCostType(option)}
              // disable={this.state.multiselectEnable}
              endListContent={
                <ColorButton
                  className="gray-btn"
                  // text="Add cost type"
                  text={lang.property.text_cost_addcosttype}
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({addHeatingCostModalOpen: true});
                  }}
                />
              }
              removeLongTextHiding={true}
            />
            {
              this.state.errors.heatigCostType && (
                <Alert color="red"><Text size="xs" color="red">{this.state.errors.heatigCostType}</Text></Alert>
              )
            }
          </Form.Group>
        </Col>
      </Row>
    );
  }

  resetVatNetAmountfieldsToNull=()=>{
    this.setState({
      netAmount: '',
      vatAmount: '',
      customVatType: ''
    }, ()=> this.setState({
      netAmount: null,
      vatAmount: null,
      customVatType: null
    }))
  }

  renderFormFields = () => {
    const { edit, record, costAllocation, currentSubscription, accountData, memoryStatusExceededPackageWise, usedSpaceInMB } = this.props;
    const { customDate, timeframe, selectedCostType, selectedFile, receiptName, isMobile, vatTypes, taxCostTypes, selectedVatType, selectedTaxCostType, customVatType, hoverOnStarter, vatInFocus, amountInFocus, netInFocus, vatPercentInFocus, laborCostInFocus, costTypeOptions, notes, receiptNumber, amount, firstTimeAmountNegative, netAmount, vatAmount, laborCost } = this.state;

    console.log('renderFormFields: ', selectedVatType);
    console.log('renderFormFields: ', selectedTaxCostType);
    console.log('renderFormFields-3: ', customVatType);

    return (
      <div className="modal-inner-body add-receipt-modal">
        <Row>
          <Col xs={12}>
            <DropFile
              filename={edit && receiptName}
              err={this.state.selectedFileErr.state}
              edit={edit}
              receiptModal={true}
              accept={'.jpg,.jpeg,.png,application/pdf'}
              // Beyond a Professional plan's 2 GB, storage is charged: a prepaid partner plan (#2357)
              // without a payment method gets one first.
              handleDrop={(acceptedFile, rejectedFile) => requiresPaymentMethodForStorage(currentSubscription, accountData, usedSpaceInMB) ? this.setState({ openPaymentMethodRequired: true }) : memoryStatusExceededPackageWise ? this.setState({ openPaidModal: true }) : acceptedFile.length > 1 ? this.setState({ acceptedFiles: acceptedFile, rejectedFiles: rejectedFile, openAddMultipleDocumentsCofirmationModal: true }) : this.handleFileChange(acceptedFile, rejectedFile)}
              file={selectedFile}
              removeFile={this.removeImage}
              secondText={'JPG, PNG oder PDF, max. 20 MB'}
              maxSize={20000000}
              multiple={false}
              onClick={() => this.setState({ imageOpen: true })}
              fileType={this.getFileExtension(edit ? (record && record.file_name !== '' ? record.file_name : Receipt) : selectedFile ? selectedFile[0].name : Receipt)}
            />
            {this.state.selectedFileErr.state && (
              <ValueText className="error" text={this.state.selectedFileErr.msg} />
            )}
          </Col>
        </Row>

        {/* AI Banner - Different for Mobile vs Desktop */}
        {edit === false && (
          <Row style={{ marginTop: isMobile ? '0px' : '-10px' }}>
            <Col xs={12}>
              <Form.Group>
                <Form.Label>
                  {isMobile ? (
                    <Group gap={10} align={'center'}>
                      {UtilityBillingAssignedIcon(isStarterTier(currentSubscription) ? '#9A9AB5' : '#5555FF')}
                      <span>{`Automatische Belegerkennung (KI) ${isStarterTier(currentSubscription) ? 'ist nicht aktiviert.' : 'ist aktiviert.'}`}</span>
                    </Group>
                  ) : (
                    <Popover
                      opened={isStarterTier(currentSubscription) && hoverOnStarter}
                      onChange={(opened) => { if (!opened) this.setState({ hoverOnStarter: false }); }}
                      position="top"
                      withArrow
                      trapFocus={false}
                      closeOnEscape={false}
                      transitionProps={{ transition: 'pop-top-left' }}
                      width={300}
                      zIndex={9999}
                    >
                      <Popover.Target>
                        <Group gap={5} align="center" onClick={() => this.setState({ hoverOnStarter: !hoverOnStarter })} style={{ cursor: 'pointer', width: '100%' }}>
                          {UtilityBillingAssignedIcon(isStarterTier(currentSubscription) ? '#9A9AB5' : '#5555FF')}
                          <span style={{ color: '#0E0E1D' }}>
                            {`Automatische Belegerkennung (KI) ${isStarterTier(currentSubscription) ? 'ist nicht aktiviert.' : 'ist aktiviert.'}`}
                          </span>
                          {isStarterTier(currentSubscription) && (
                            <img src={GoldenLockIcon} style={{ marginTop: '-2px' }} alt="lock" />
                          )}
                        </Group>
                      </Popover.Target>
                      <Popover.Dropdown p={0}>
                        <Stack style={{ padding: '10px' }} gap={15} onMouseEnter={() => this.setState({ hoverOnStarter: true })} onMouseLeave={() => this.setState({ hoverOnStarter: false })}>
                          <Group><span style={{ color: 'rgb(85, 85, 255)', fontSize: '1rem' }}>Automatische Belegerkennung (KI)</span></Group>
                          <Group justify="center" wrap="nowrap">
                            <img src={GoldenLockIcon} width="18px" alt="lock" />
                            <span style={{ color: '#5f5f7a', fontSize: '11px', fontWeight: '400' }}>
                              Sparen Sie Zeit mit <span style={{ fontWeight: '500' }}>hellohousing Premium</span> und lassen Sie wichtige Belegdaten beim Hochladen automatisch auslesen.
                            </span>
                          </Group>
                          <Group justify="center">
                            <ColorButton text={'Jetzt freischalten'} onClick={() => this.props.history.push('/profile/yourSubscription', { newSubscription: true })} className="purple-btn" />
                          </Group>
                        </Stack>
                      </Popover.Dropdown>
                    </Popover>
                  )}
                </Form.Label>
              </Form.Group>
            </Col>
          </Row>
        )}

        {/* Basic Info: Receipt Name */}
        <Row style={{ marginTop: '5px' }}>
          <Col xs={12}>
            <Form.Group>
              <Form.Label> {lang.receipt.text_receipt_name} *</Form.Label>
              <Form.Control
                isInvalid={!!this.state.errors.title}
                type="text"
                value={receiptName}
                onChange={(e) => this.onInputChange('receiptName', e.target.value)}
                onKeyPress={this.handleEnterKeyPress}
              />
              {this.state.errors.title && <Alert color="red"><Text size="xs" color="red">{this.state.errors.title}</Text></Alert>}
            </Form.Group>
          </Col>
        </Row>

        {/* Basic Info: Number & Date */}
        <Row style={{ marginTop: '5px' }}>
          <Col xs={6}>
            <Form.Group>
              <Form.Label> {'Belegnummer (optional)'}</Form.Label>
              <Form.Control type="text" value={receiptNumber || ''} onChange={(e) => this.onInputChange('receiptNumber', e.target.value)} onKeyPress={this.handleEnterKeyPress} />
            </Form.Group>
          </Col>
          <Col xs={6}>
            <Form.Group>
              <Form.Label> {lang.receipt.text_date} </Form.Label>
              <div className={`calendar-input`}>
                <img src={calendar} alt="calendar" />
                <DatePicker locale="de" formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 1)} dateFormat="dd.MM.yyyy" customInput={<Form.Control required type="text" placeholder="TT.MM.JJJJ" />} style={{ display: 'block !important' }} selected={new Date(this.state.date)} onChange={(e) => this.onDateChange('date', e)} popperModifiers={{ preventOverflow: { enabled: true } }} />
              </div>
            </Form.Group>
          </Col>
        </Row>

        {/* Amount */}
        <Row style={{ marginTop: '6px', marginBottom: '5px' }}>
          <Col xs={6}>
            <Form.Group>
              <Form.Label> {lang.receipt.text_amount} *</Form.Label>
              <NumericFormat
                className='form-control'
                value={amount}
                thousandSeparator="."
                decimalSeparator=","
                // NumericFormat also fires this when `value` is set programmatically (AI extraction, edit load);
                // only a typed first amount defaults to Ausgabe, a value we set already carries its sign
                onValueChange={(values, sourceInfo) => this.onInputChange('amount', firstTimeAmountNegative && sourceInfo.source === 'event' ? -values.floatValue : values.floatValue)}
                suffix={' €'}
                onKeyPress={this.handleEnterKeyPress}
                placeholder='0,00 €'
                onFocus={() => this.setState({ amountInFocus: true })}
                onBlur={() => this.setState({ amountInFocus: false })}
                decimalScale={amountInFocus === false ? 2 : 5}
                allowNegative={true}
              />
              {this.state.errors.amount && <Alert color="red"><Text size="xs" color="red">{this.state.errors.amount}</Text></Alert>}
            </Form.Group>
          </Col>
          <Col xs={6}>
            <Group wrap="nowrap" justify='left' align={'center'} style={{ height: '100%', marginTop: '4px' }}>
              <div style={{ width: '100%', textAlign: 'center' }} className={amount < 0 ? 'add-receipt-modal-amount-negative' : 'add-receipt-modal-amount-negative-disabled'} onClick={() => this.setState({ amount: amount && -amount, netAmount: netAmount && -netAmount, vatAmount: vatAmount && -vatAmount, laborCost: laborCost && -laborCost })}>Ausgabe</div>
              <div style={{ width: '100%', textAlign: 'center' }} className={amount > 0 ? 'add-receipt-modal-amount-positive' : 'add-receipt-modal-amount-positive-disabled'} onClick={() => this.setState({ amount: amount && Math.abs(amount), netAmount: netAmount && Math.abs(netAmount), vatAmount: vatAmount && Math.abs(vatAmount), laborCost: laborCost && Math.abs(laborCost) })}>Guthaben</div>
            </Group>
          </Col>
        </Row>

        {/* VAT Inputs */}
        <span className='modal-sub-headings'>Mehrwertsteuer <span className='optional-label'>(optional)</span></span>
        <Row style={{ marginTop: '6px', marginBottom: '5px' }}>
          <Col xs={4}>
            <Form.Group>
              <Form.Label style={{ whiteSpace: 'nowrap' }}>MwSt.-Satz</Form.Label>
              {selectedVatType[0]?.label !== 'anderer' && (
                <SelectDropdown options={vatTypes} selectedValue={selectedVatType.length > 0 && selectedVatType[0]} onSelect={this.onVatPercentageSelect} onRemove={this.onVatPercentageRemove} displayValue="label" placeholder={lang.newKeys.text_select} showSelectedHighlight={false} ddHeaderClassName={`custom-select-dropdown ${selectedVatType.length > 0 && selectedVatType[0]?.label && 'custom-select-dropdown-pt-0'}`} disable={!amount} clearable={true} />
              )}
              {selectedVatType.length > 0 && selectedVatType[0]?.label === 'anderer' && (
                <Group className='form-control d-flex align-items-center' wrap="nowrap" gap={3} style={{ padding: '0 8px 7px 0' }}>
                  <NumericFormat
                    className='form-control form-control-transparent'
                    style={{ border: 'none', boxShadow: 'none', flex: 1, backgroundColor: 'transparent' }}
                    value={customVatType}
                    thousandSeparator="."
                    decimalSeparator=","
                    onValueChange={(values) => {
                      console.log('customVatType: ', values);
                      this.onInputChange('customVatType', values.formattedValue)
                    }}
                    suffix={' %'}
                    onKeyPress={this.handleEnterKeyPress}
                    placeholder='0,00 %'
                    // onFocus={() => this.setState({ vatPercentInFocus: true })}
                    // onBlur={() => this.setState({ vatPercentInFocus: false })}
                    decimalScale={2}
                    allowNegative={true}
                  />
                  <div onClick={() => this.setState({ selectedVatType: [], customVatType: null, vatAmount: '', netAmount: '' })} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                    <div className="mantine-ActionIcon-transparent mantine-ActionIcon-root" type="button" tabIndex="0"><img src={CloseButtonIcon} alt="close icon" /></div>
                  </div>
                </Group>
              )}
            </Form.Group>
          </Col>
          <Col xs={4}>
            <Form.Group>
              <Form.Label style={{ whiteSpace: 'nowrap' }}>Netto-Betrag</Form.Label>
              <NumericFormat className='form-control' value={netAmount} thousandSeparator="." decimalSeparator="," onValueChange={(values) => this.onInputChange('netAmount', values.floatValue)} suffix={' €'} onKeyPress={this.handleEnterKeyPress} placeholder='0,00 €' onFocus={() => this.setState({ netInFocus: true })} onBlur={() => this.setState({ netInFocus: false })} decimalScale={netInFocus === false ? 2 : 5} allowNegative={true} disabled={!amount} />
            </Form.Group>
          </Col>
          <Col xs={4}>
            <Form.Group>
              <Form.Label style={{ whiteSpace: 'nowrap' }}>MwSt.-Betrag</Form.Label>
              <NumericFormat className='form-control' value={vatAmount} thousandSeparator="." decimalSeparator="," onValueChange={(values) => this.onInputChange('vatAmount', values.floatValue)} suffix={' €'} onKeyPress={this.handleEnterKeyPress} placeholder='0,00 €' onFocus={() => this.setState({ vatInFocus: true })} onBlur={() => this.setState({ vatInFocus: false })} decimalScale={vatInFocus === false ? 2 : 5} allowNegative={true} disabled={!amount} />
            </Form.Group>
          </Col>
        </Row>

        {/* Labor Cost */}
        <span className='modal-sub-headings'>Lohnkosten <span className='optional-label'>(optional)</span></span>
        <Row style={{ marginTop: '6px', marginBottom: '5px' }}>
          <Col xs={12}>
            <Form.Group>
              <Form.Label>Enthaltene Lohnkosten nach §35a EStG</Form.Label>
              <NumericFormat className='form-control' value={laborCost} thousandSeparator="." decimalSeparator="," onValueChange={(values) => this.onInputChange('laborCost', values.floatValue)} suffix={' €'} onKeyPress={this.handleEnterKeyPress} placeholder='0,00 €' onFocus={() => this.setState({ laborCostInFocus: true })} onBlur={() => this.setState({ laborCostInFocus: false })} decimalScale={laborCostInFocus === false ? 2 : 5} allowNegative={true} />
            </Form.Group>
          </Col>
        </Row>

        {/* Tax Cost Type */}
        <span className='modal-sub-headings'>Kostenart <span className='optional-label'>(optional)</span></span>
        <Row style={{ marginTop: '6px', marginBottom: '5px' }}>
          <Col xs={12}>
            <Form.Group>
              <Form.Label>Steuerliche Kostenart</Form.Label>
              <SelectDropdown options={taxCostTypes.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()))} selectedValue={selectedTaxCostType[0]} onSelect={this.onTaxCostTypeSelect} onRemove={this.onTaxCostTypeRemove} displayValue="label" placeholder={lang.newKeys.text_select} showSelectedHighlight={false} removeLongTextHiding={true} currentSubscription={currentSubscription} clearable={true} />
            </Form.Group>
          </Col>
        </Row>

        {/* Utility Bills / Betriebskosten */}
        <span className='modal-sub-headings'>Betriebskosten</span>
        <Row style={{ marginTop: '6px', marginBottom: '5px' }}>
          <Col xs={12}>
            <SwitchContainer disabled={false} switchText={lang.receipt.text_utility_bill_relevant} onColor="#5555FF" offColor="#DADAE6" onChange={this.props.billingRelevant ? () => { } : this.handleCheck} checked={this.props.billingRelevant ? true : this.state.UtilityBillFilter} height={16} width={28} handleDiameter={1.8} />
          </Col>
        </Row>
        
        {this.state.UtilityBillFilter && !costAllocation && (
          <>
            <Row style={{ marginTop: '10px' }}>
              <Col xs={12}>
                <Form.Group>
                  <Form.Label> Betriebskostenart *</Form.Label>
                  <SelectDropdown options={costTypeOptions.sort((a, b) => a.costTypeName.localeCompare(b.costTypeName))} selectedValue={selectedCostType[0]} onSelect={this.onCostTypeSelect} onRemove={this.onCostTypeRemove} displayValue="costTypeName" placeholder={lang.newKeys.text_select} disable={this.state.multiselectEnable} endListContent={<ColorButton className="gray-btn" text={lang.property.text_cost_addcosttype} onClick={(e) => { e.preventDefault(); this.toggleAddCostTypeModal(); }} />} removeLongTextHiding={true} />
                  {this.state.errors.costType && <Alert color="red"><Text size="xs" color="red">{this.state.errors.costType}</Text></Alert>}
                </Form.Group>
              </Col>
            </Row>

            {selectedCostType[0]?.systemCostTypeId === '941b0728-4a63-4d90-a80b-3de2bb80c0b1' && this.renderHeatingCostAllocatorSection()}
            
            <div className="time-frame-section" style={{ marginTop: '5px' }}>
              <Form.Group>
                <div className="time-frame-heading">
                  <Form.Label> {lang.receipt.text_time_frame}</Form.Label>
                </div>
                <div className="time-frame-options">
                  <div className={`single-time-option hello-housing-radio-options ${timeframe === 'current' ? `checked` : ``} `}>
                    <Form.Check checked={timeframe === 'current'} id="current" type="radio" name="timeframe" label={lang.receipt.text_current_billing_period} onChange={(e) => this.onInputChange('timeframe', e.target.id)} onKeyPress={this.handleEnterKeyPress} />
                    <span>{this.state.currentStartDate} - {this.state.currentEndDate}</span>
                  </div>
                  <div className={`single-time-option hello-housing-radio-options ${timeframe === 'last' ? `checked` : ``} `}>
                    <Form.Check checked={timeframe === 'last'} id="last" type="radio" name="timeframe" label={lang.receipt.text_last_billing_period} onChange={(e) => this.onInputChange('timeframe', e.target.id)} onKeyPress={this.handleEnterKeyPress} />
                    <span>{this.state.previousStartDate} - {this.state.previousEndDate}</span>
                  </div>
                  <div className={`single-time-option hello-housing-radio-options ${timeframe === 'custom' ? `checked` : ``} `}>
                    <Form.Check checked={timeframe === 'custom'} id="custom" type="radio" name="timeframe" label={lang.receipt.text_custom} onChange={(e) => this.onInputChange('timeframe', e.target.id)} onKeyPress={this.handleEnterKeyPress} />
                    <span>{customDate.start && customDate.end ? `${this.formatReceiptDate(customDate.start)} – ${this.formatReceiptDate(customDate.end)}` : '-'}</span>
                  </div>
                </div>
                {timeframe === 'custom' && (
                  <div className="custom-date-field">
                    <Form.Group>
                      <Form.Label> {lang.receipt.text_time_frame} </Form.Label>
                      <RangeDatePicker locale="de" customDate={customDate} setDate={(date) => this.setState({ customDate: date })} />
                    </Form.Group>
                  </div>
                )}
              </Form.Group>
            </div>
          </>
        )}

        {/* Notes */}
        <div style={{ marginTop: '14px' }}>
          <span className='modal-sub-headings'>Notizen</span>
          <Row style={{ marginTop: '6px', marginBottom: '5px' }}>
            <Col xs={12}>
              <Form.Group>
                <Group justify='right' style={{ width: '100%' }}>
                  <Form.Label style={{ paddingRight: '0px' }}> {`${notes ? notes.length : 0}/1000`}</Form.Label>
                </Group>
                <Form.Control type="textarea" value={notes || ''} onChange={(e) => (e.target.value && e.target.value.length > 1000) ? showNotification({ message: 'Sie haben die maximale Eingabegröße für das Notizfeld überschritten.', icon: <img src={RedCross} alt='red-cross' />, id: 'notesLimitExceed' }) : this.onInputChange('notes', e.target.value)} as="textarea" style={{ height: 108, width: '100%' }} />
              </Form.Group>
            </Col>
          </Row>
        </div>
      </div>
    );
  };

  // closing without saving: a parent whose toggle reloads its list can pass onCancel to skip that
  cancel = () => {
    const { onCancel, toggle } = this.props;
    this.resetForm();
    onCancel ? onCancel() : toggle();
  };

  renderFormButtons = () => {
    const { edit } = this.props;

    return (
      <div style={{ marginTop: '5px' }} className="center-spacing add-receipt-modal-footer" id="receipt-add-edit-btns">
        <div>
          <ColorButton
            onClick={this.cancel}
            className="gray-btn"
            text={lang.general.text_cancel}
          />
        </div>
        <div>
          <ColorButton
            buttonConfig={{ type: 'submit' }}
            className="purple-btn"
            text={edit ? lang.receipt.text_mobile_save_receipt : lang.receipt.text_mobile_add_receipt}
            disabled={this.state.isFormValid}
          />
        </div>
      </div>
    );
  };

  render() {
    const { open, toggle, className, edit, record, costAllocation, currentSubscription, accountData, usedSpaceInMB, memoryStatusExceededPackageWise, transactionAssigment=null } = this.props;
    const { selectedFile, imgScale, isMobile, aiLoader, openPaidModal, openPaidModalForTaxCostType, selectedFiles, openMultipleReceiptsUploadModal, openAddMultipleDocumentsCofirmationModal, acceptedFiles, rejectedFiles, selectedFileEncrypted, addHeatingCostModalOpen, imageOpen } = this.state;

    return (
      <>
        <CustomModal
          heading={edit ? lang.receipt.text_edit_receipt : lang.receipt.text_add_receipt}
          headingClassName={edit ? 'receipt-management-edit-receipt' : 'receipt-management-add-receipt'}
          open={open}
          toggle={this.cancel}
          className={`${className} ${(selectedFile && selectedFile[0]) && !isMobile && 'receipt-main-modal'}`}
        >
          <div id="form-parent-div">
            {isMobile ? (
              <Stack gap='xl' justify='space-between'>
                {/* Mobile Preview Area */}
                {(selectedFile || (record && record.file_name !== '')) && (
                  <Stack className="main-div" style={{ position: 'relative' }}>
                    <LoadingOverlay visible={aiLoader} loader={<Stack gap={0} align={'center'}><img src='/aiSearchIcon.gif' width={'100px'}/><span style={{color: '#5555FF'}}>Belegdaten werden ausgelesen ...</span></Stack>} overlayOpacity={0.6}/>
                    <div style={{ background: 'grey', minWidth: '100%', minHeight: '400px', maxHeight: '400px', overflow: edit ? (record && record.file_name !== '' ? 'scroll' : (selectedFile ? 'scroll' : 'hidden')) : selectedFile ? 'scroll' : 'hidden', borderRadius: '4px', border: '1px solid #DADAE6' }}>
                      <FilePreview file={selectedFile ? selectedFile[0] : Receipt} billingRelevantSwitch={this.props.billingRelevant ? true : this.state.UtilityBillFilter} imgScale={imgScale} edit={edit} onExpand={() => this.setState({ imageOpen: true })} costAllocation={costAllocation} isMobile={isMobile} addFile={() => this.fileInputRef.current.click()} removePage={(pageNumber) => this.removePageFromPDF(pageNumber)} />
                    </div>
                    {/* File actions */}
                    <Group wrap="nowrap">
                      <ColorButton text={'Belegseite(n) ergänzen'} className={'gray-btn'} leftImage={{ img: AddPages, style: { width: '16px', height: '16px', marginRight: '5px', marginTop: '-2px' } }} buttonStyle={{ opacity: selectedFileEncrypted ? 0.6 : 1 }} disabled={!(selectedFile && selectedFile[0])} onClick={() => selectedFileEncrypted ? this.renderRestrictedFunctionMessage() : this.fileInputRef.current.click()} />
                      <ColorButton text={'Belegseite löschen'} buttonStyle={{ minWidth: '167px', opacity: selectedFileEncrypted ? 0.6 : 1 }} className={'gray-btn'} leftImage={{ img: RemovePages, style: { width: '16px', height: '16px', marginRight: '5px', marginTop: '-2px' } }} disabled={!(selectedFile && selectedFile[0])} onClick={() => selectedFileEncrypted ? this.renderRestrictedFunctionMessage() : document.getElementById('remove-page').click()} />
                    </Group>
                  </Stack>
                )}
                {/* Mobile Form Area */}
                <Group style={{ alignSelf: 'stretch' }}>
                  <Form onSubmit={(e) => this.handleSubmit(e)} id='receipt-add-edit-form' style={{ width: '100%', height: '100%' }}>
                    <Stack style={{ height: '100%' }} justify='space-between'>
                      <input type="file" ref={this.fileInputRef} id='add-file-to-existing' accept="image/*,.pdf" multiple onChange={this.handleFileAdd} style={{ display: 'none' }} />
                      {this.renderFormFields()}
                      {this.renderFormButtons()}
                    </Stack>
                  </Form>
                </Group>
              </Stack>
            ) : (
              <Group wrap="nowrap" align={'flex-start'} gap='xl' justify="space-between">
                {/* Desktop Preview Area */}
                {(selectedFile && selectedFile[0]) && (
                  <Group className="main-div" style={{ position: 'relative' }}>
                    <LoadingOverlay visible={aiLoader} loader={<Stack gap={0} align={'center'}><img src='/aiSearchIcon.gif' width={'100px'}/><span style={{color: '#5555FF'}}>Belegdaten werden ausgelesen ...</span></Stack>} overlayOpacity={0.6}/>
                    <div style={{ background: 'grey', minWidth: '700px', maxWidth: '700px', minHeight: '700px', maxHeight: '700px', overflow: edit ? (record && record.file_name !== '' ? 'scroll' : (selectedFile ? 'scroll' : 'hidden')) : selectedFile ? 'scroll' : 'hidden', borderRadius: '4px', border: '1px solid #DADAE6' }}>
                      <FilePreview file={selectedFile ? selectedFile[0] : Receipt} billingRelevantSwitch={this.props.billingRelevant ? true : this.state.UtilityBillFilter} imgScale={imgScale} edit={edit} onExpand={() => this.setState({ imageOpen: true })} costAllocation={costAllocation} addFile={() => this.fileInputRef.current.click()} removePage={(pageNumber) => this.removePageFromPDF(pageNumber)} />
                    </div>
                    {/* File actions */}
                    <Stack gap={5}>
                      <Group wrap="nowrap">
                        <ColorButton text={'Belegseite(n) ergänzen'} className={'gray-btn'} leftImage={{ img: AddPages, style: { width: '16px', height: '16px', marginRight: '5px', marginTop: '-2px' } }} buttonStyle={{ opacity: selectedFileEncrypted ? 0.6 : 1 }} disabled={!(selectedFile && selectedFile[0])} onClick={() => selectedFileEncrypted ? this.renderRestrictedFunctionMessage() : this.fileInputRef.current.click()} />
                        <ColorButton text={'Belegseite löschen'} buttonStyle={{ minWidth: '167px', opacity: selectedFileEncrypted ? 0.6 : 1 }} className={'gray-btn'} leftImage={{ img: RemovePages, style: { width: '16px', height: '16px', marginRight: '5px', marginTop: '-2px' } }} disabled={!(selectedFile && selectedFile[0])} onClick={() => selectedFileEncrypted ? this.renderRestrictedFunctionMessage() : document.getElementById('remove-page').click()} />
                      </Group>
                    </Stack>
                  </Group>
                )}
                {/* Desktop Form Area */}
                <Group style={{ minWidth: (selectedFile && selectedFile[0]) ? '430px' : '100%', maxWidth: (selectedFile && selectedFile[0]) ? '430px' : '100%', alignSelf: 'stretch' }}>
                  <Form onSubmit={(e) => this.handleSubmit(e)} id='receipt-add-edit-form' style={{ width: '100%', height: '100%' }}>
                    <Stack style={{ height: '100%' }} justify='space-between'>
                      <input type="file" ref={this.fileInputRef} id='add-file-to-existing' accept="image/*,.pdf" multiple onChange={this.handleFileAdd} style={{ display: 'none' }} />
                      <span className='modal-sub-headings'>Belegdaten</span>
                      {this.renderFormFields()}
                      {this.renderFormButtons()}
                    </Stack>
                  </Form>
                </Group>
              </Group>
            )}
          </div>
        </CustomModal>
        
        {/* Modals remain mostly unchanged */}
        {addHeatingCostModalOpen && <AddHeatingCostModal open={addHeatingCostModalOpen} toggle={() => this.setState({addHeatingCostModalOpen: false})} saveHeatingCost={(heatingCost) => this.setState({addHeatingCostModalOpen: false}, () => this.createHeatingCostType(heatingCost))} />}
        {this.state.AddCostTypeModal && <AddCostTypeModal record={null} className="add_cost_type_modal" edit={false} open={this.state.AddCostTypeModal} showCostData={this.state.costTypeOptions} toggle={this.toggleAddCostTypeModal} parent={this} callBackFunction={(id=null) => this.getCostTypes(id)} />}
        {imageOpen && <ImageModal img={edit ? (record && record.file_name !== '' ? record.file_name : Receipt) : selectedFile ? selectedFile[0] : Receipt} className="expandImageModal" open={imageOpen} toggle={() => this.setState({imageOpen: !imageOpen})} receiptDetailModalAdd={!edit} />}
        {openPaidModal && <BuyPremiumModal heading={'Zusätzlichen Speicherplatz freischalten'} open={openPaidModal} text={<span style={{fontSize: '15px', color: 'rgb(19, 19, 92)', fontWeight: '400', textAlign: 'center', width: '350px'}}>Sie haben {usedSpaceInMB ? formatNumber(isStarterTier(currentSubscription) ? usedSpaceInMB : (usedSpaceInMB / 1000), false) : '0,00'} MB von {isStarterTier(currentSubscription) ? "100,00 MB" : "2,0 GB"} verfügbarem Speicherplatz im Starter Paket genutzt. Schalten Sie hellohousing <span onClick={()=> this.props.history.push('/profile/yourSubscription', {newSubscription: true})} style={{color: 'rgb(85, 85, 255)', textDecoration: 'underline', cursor: 'pointer'}}>{isStarterTier(currentSubscription) ? 'Premium' : 'Professional'}</span> frei, um weiteren Speicherplatz zu nutzen.</span>} onClick={()=> this.props.history.push('/profile/yourSubscription', {newSubscription: true})} onCancel={()=> this.setState({openPaidModal: false})} />}
        <PaymentMethodRequiredModal open={this.state.openPaymentMethodRequired} addOn="storage" onClose={() => this.setState({ openPaymentMethodRequired: false })} onNavigate={() => toggle()} />
        {openPaidModalForTaxCostType && <BuyPremiumModal heading={'Auswahl der Steuerkostenart freischalten'} open={openPaidModalForTaxCostType} text={<span style={{fontSize: '15px', color: 'rgb(19, 19, 92)', fontWeight: '400', textAlign: 'center', width: '350px'}}>Aktivieren Sie hellohousing <span onClick={()=> this.props.history.push('/profile/yourSubscription', {newSubscription: true})} style={{color: 'rgb(85, 85, 255)', textDecoration: 'underline', cursor: 'pointer'}}>{isStarterTier(currentSubscription) ? 'Premium' : 'Professional'}</span>, um Steuerkostenarten festzulegen und alle Daten für die Steuererklärung (Anlage V) abzurufen und zu exportieren.</span>} onClick={()=> this.props.history.push('/profile/yourSubscription', {newSubscription: true})} onCancel={()=> this.setState({openPaidModalForTaxCostType: false})} />}
        {openMultipleReceiptsUploadModal && <MultipleReceiptsUploadModal open={openMultipleReceiptsUploadModal} selectedFiles={selectedFiles} propertySelected={this.props.propertySelected} toggle={(closeAll)=> this.setState({openMultipleReceiptsUploadModal: false}, ()=> closeAll && toggle())} showFirstRowLoader={()=> this.props.showFirstRowLoader()} setSelectedFiles={(selectedFiles)=> this.handleFileChange(selectedFiles, [])} />}
        {openAddMultipleDocumentsCofirmationModal && <AddMultipleDocumentsCofirmationModal open={openAddMultipleDocumentsCofirmationModal} numberOfFiles={acceptedFiles.length} toggle={()=> this.setState({openAddMultipleDocumentsCofirmationModal: false, acceptedFiles: [], rejectedFiles: []})} next={()=> this.setState({openAddMultipleDocumentsCofirmationModal: false}, ()=> this.handleFileChange(acceptedFiles, rejectedFiles))} />}
        
        <button style={{display: 'none'}} id='uploadReceiptDocs'/>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    propertySelected: state.generalReducer.property,
    currentSubscription: state.generalReducer.currentSubscription,
    accountData: state.generalReducer.accountData,
    profileData: state.generalReducer.profile
  };
};

const actions = {
  setAddReceiptModal, 
  setReceiptCurrentId, 
  setReceiptFiles,
  setRefreshReceiptDocumentsData
};

export default connect(mapStateToProps, actions)(ReceiptDetailModal);
